msgid ""
msgstr ""
"POT-Creation-Date: 2025-01-07 14:43+0300\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: pl\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-explicit-id
#: src/utils/validation.js:5
#: src/utils/validation.js:13
msgid "validation:phone"
msgstr "validation:phone"

#. js-lingui-explicit-id
#: src/utils/validation.js:8
#: src/utils/validation.js:16
msgid "validation:phoneLength"
msgstr "validation:phoneLength"

#. js-lingui-explicit-id
#: src/utils/validation.js:23
#: src/utils/valid.ts:21
#: src/utils/i18n-legacy.ts:69
#: src/containers/Users/NewUser.tsx:40
msgid "validation:required"
msgstr "validation:required"

#. js-lingui-explicit-id
#: src/utils/validation.js:27
#: src/utils/valid.ts:16
msgid "validation:no_spaces"
msgstr "validation:no_spaces"

#. js-lingui-explicit-id
#: src/utils/validation.js:38
msgid "validation:one_lathin_lowercase_letter"
msgstr "validation:one_lathin_lowercase_letter"

#. js-lingui-explicit-id
#: src/utils/validation.js:39
msgid "validation:one_lathin_uppercase_letter"
msgstr "validation:one_lathin_uppercase_letter"

#. js-lingui-explicit-id
#: src/utils/validation.js:40
msgid "validation:one_digit"
msgstr "validation:one_digit"

#. js-lingui-explicit-id
#: src/utils/validation.js:41
msgid "validation:more_than_8_length"
msgstr "validation:more_than_8_length"

#. js-lingui-explicit-id
#: src/utils/validation.js:43
msgid "validation:password_must"
msgstr "validation:password_must"

#. js-lingui-explicit-id
#: src/utils/valid.ts:11
msgid "validation:only_lathin_alphanumeric"
msgstr "validation:only_lathin_alphanumeric"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:68
msgid "validation:invalid"
msgstr "validation:invalid"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:70
msgid "validation:notType"
msgstr "validation:notType"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:73
msgid "validation:min"
msgstr "validation:min"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:74
msgid "validation:max"
msgstr "validation:max"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:75
msgid "validation:moreThan"
msgstr "validation:moreThan"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:76
msgid "validation:lessThan"
msgstr "validation:lessThan"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:79
msgid "validation:length"
msgstr "validation:length"

#. js-lingui-explicit-id
#: src/utils/error.ts:17
msgid "operation-error"
msgstr "operation-error"

#. js-lingui-explicit-id
#: src/utils/cartridge.ts:20
msgid "ui:units.volume"
msgstr "ui:units.volume"

#. js-lingui-explicit-id
#: src/utils/cartridge.ts:22
msgid "ui:units.hours"
msgstr "ui:units.hours"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:9
msgid "errors:incorrect_login_or_password"
msgstr "errors:incorrect_login_or_password"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:17
#: src/errors/userErrors.ts:23
msgid "errors:password_change_required"
msgstr "errors:password_change_required"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:29
msgid "errors:incorrect_confirmation_code"
msgstr "errors:incorrect_confirmation_code"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:35
msgid "errors:user_blocked"
msgstr "errors:user_blocked"

#. js-lingui-explicit-id
#: src/errors/baseErrors.js:7
msgid "errors:limit_reached"
msgstr "errors:limit_reached"

#. js-lingui-explicit-id
#: src/containers/Terminals/NewDevice/DeviceBaseFields.tsx:36
msgid "validation:incorrect_device_key"
msgstr "validation:incorrect_device_key"

#. js-lingui-explicit-id
#: src/containers/Profile/EditProfile.tsx:23
msgid "validation:email"
msgstr "validation:email"

#. js-lingui-explicit-id
#: src/containers/Profile/ChangePassword.tsx:20
msgid "login:message.password_mismatch"
msgstr "login:message.password_mismatch"

#. js-lingui-explicit-id
#: src/containers/DeviceList/columns/waterPlusColumns.tsx:46
msgid "ui:units.liters"
msgstr "ui:units.liters"

#. js-lingui-explicit-id
#: src/components/TerminalState.tsx:37
msgid "ui:yes"
msgstr "ui:yes"

#. js-lingui-explicit-id
#: src/components/TerminalState.tsx:37
msgid "ui:no"
msgstr "ui:no"

#. js-lingui-explicit-id
#: src/components/CartridgeValue/utils.ts:9
msgid "cartridges:step.OptionalMineralizer"
msgstr "cartridges:step.OptionalMineralizer"

#: src/containers/OraclePage/ComputeTab/utils.ts:247
msgid ""
"\n"
"\n"
"Детальный расчёт доходов (выручка):"
msgstr ""
"\n"
"\n"
"Szczegółowe obliczenie przychodów (przychód):"

#: src/containers/OraclePage/ComputeTab/utils.ts:277
msgid ""
"\n"
"\n"
"Детальный расчёт расходов:"
msgstr ""
"\n"
"\n"
"Szczegółowe obliczenie wydatków:"

#: src/containers/OraclePage/ComputeTab/utils.ts:328
msgid ""
"\n"
"Аренда:"
msgstr ""
"\n"
"Wynajem:"

#: src/containers/OraclePage/ComputeTab/utils.ts:335
msgid ""
"\n"
"Вода:"
msgstr ""
"\n"
"Woda:"

#: src/containers/OraclePage/ComputeTab/utils.ts:266
msgid ""
"\n"
"Доход от рекламы:"
msgstr ""
"\n"
"Przychód z reklamy:"

#: src/containers/OraclePage/ComputeTab/utils.ts:362
msgid ""
"\n"
"Мониторинг:"
msgstr ""
"\n"
"Monitoring:"

#: src/containers/OraclePage/ComputeTab/utils.ts:464
msgid ""
"\n"
"Налогообложение:"
msgstr ""
"\n"
"Opodatkowanie:"

#: src/containers/OraclePage/ComputeTab/utils.ts:459
msgid ""
"\n"
"Обслуживание кредита:"
msgstr ""
"\n"
"Obsługa kredytu:"

#: src/containers/OraclePage/ComputeTab/utils.ts:422
msgid ""
"\n"
"Пересчёт монет:"
msgstr ""
"\n"
"Przeliczanie monet:"

#: src/containers/OraclePage/ComputeTab/utils.ts:357
msgid ""
"\n"
"Персонал:"
msgstr ""
"\n"
"Personel:"

#: src/containers/OraclePage/ComputeTab/utils.ts:263
msgid ""
"\n"
"Продажи:"
msgstr ""
"\n"
"Sprzedaż:"

#: src/containers/OraclePage/ComputeTab/utils.ts:271
msgid ""
"\n"
"Прочие доходы:"
msgstr ""
"\n"
"Inne przychody:"

#: src/containers/OraclePage/ComputeTab/utils.ts:412
msgid ""
"\n"
"Разовые расходы за период:"
msgstr ""
"\n"
"Jednorazowe wydatki za okres:"

#: src/containers/OraclePage/ComputeTab/utils.ts:367
msgid ""
"\n"
"Фильтр 1 ступень:"
msgstr ""
"\n"
"Filtr 1 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:372
msgid ""
"\n"
"Фильтр 2 ступень:"
msgstr ""
"\n"
"Filtr 2 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:377
msgid ""
"\n"
"Фильтр 3 ступень:"
msgstr ""
"\n"
"Filtr 3 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:382
msgid ""
"\n"
"Фильтр 4 ступень:"
msgstr ""
"\n"
"Filtr 4 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:387
msgid ""
"\n"
"Фильтр 5 ступень:"
msgstr ""
"\n"
"Filtr 5 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:392
msgid ""
"\n"
"Фильтр 6 ступень:"
msgstr ""
"\n"
"Filtr 6 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:397
msgid ""
"\n"
"Фильтр 7 ступень:"
msgstr ""
"\n"
"Filtr 7 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:402
msgid ""
"\n"
"Фильтр 8 ступень:"
msgstr ""
"\n"
"Filtr 8 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:407
msgid ""
"\n"
"Фильтр 9 ступень:"
msgstr ""
"\n"
"Filtr 9 stopień:"

#: src/containers/OraclePage/ComputeTab/utils.ts:439
msgid ""
"\n"
"Эквайринг:"
msgstr ""
"\n"
"Acquiring:"

#: src/containers/OraclePage/ComputeTab/utils.ts:349
msgid ""
"\n"
"Электричество:"
msgstr ""
"\n"
"Elektryczność:"

#. placeholder {0}: formatMoney(sales.Exchange || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:178
msgid "- {0} [сдача]"
msgstr "- {0} [reszta]"

#. placeholder {0}: formatMoney(data.sales.Coins || 0, currency)
#. placeholder {1}: formatMoney( data.sales.Exchange || 0, currency )
#. placeholder {2}: formatMoney(diff, currency)
#. placeholder {3}: finStatementsForPeriod.CoinConversionFeeInPercent
#: src/containers/OraclePage/ComputeTab/utils.ts:425
msgid "[{0} монет - {1} сдачи = {2} монет, {3}% затраты на пересчёт монет]"
msgstr "[{0} monet - {1} reszty = {2} monet, {3}% koszty przeliczenia monet]"

#. placeholder {0}: formatMoney( data.sales.Bankcard || 0, currency )
#. placeholder {1}: formatMoney( data.sales.MobileApp || 0, currency )
#. placeholder {2}: formatMoney(acquiringSum, currency)
#. placeholder {3}: finStatementsForPeriod.AcquiringFeeInPercent
#: src/containers/OraclePage/ComputeTab/utils.ts:442
msgid "[{0} оплат по банк. карте + {1} оплат по приложению = {2}, {3}% затраты на эквайринг]"
msgstr "[{0} płatności kartą + {1} płatności aplikacją = {2}, {3}% koszty acquiringu]"

#. placeholder {0}: formatMoney( data.income, currency )
#. placeholder {1}: formatMoney( data.intermediateValues?.expensesTotalBeforeTaxes || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:482
msgid "[выбраны \"{type}\", доходы = {0}, затраты до вычета налогов = {1}]"
msgstr "[wybrano \"{type}\", przychody = {0}, koszty przed opodatkowaniem = {1}]"

#: src/containers/OraclePage/ComputeTab/utils.ts:67
msgid "[Если нулевые значения кВт, возможно на терминале не подключена телеметрия]"
msgstr "[Jeśli wartości kW są zerowe, możliwe, że na terminalu nie jest podłączona telemetria]"

#. placeholder {0}: finStatementsForPeriod.WaterConversionRatio
#: src/containers/OraclePage/ComputeTab/utils.ts:129
msgid "[Продано {litres} литров = {waterAfterConversionM3} м3, коэффициент конвертации воды = {0}, вода на входе до фильтрации = {waterBeforeConversionM3} м3]"
msgstr "[Sprzedano {litres} litrów = {waterAfterConversionM3} m3, współczynnik konwersji wody = {0}, woda na wejściu przed filtracją = {waterBeforeConversionM3} m3]"

#. placeholder {0}: months.toFixed(2)
#: src/containers/OraclePage/ComputeTab/utils.ts:31
msgid "{0, plural, one {# месяц} two {# месяца} few {# месяцев} other {# месяцев}}"
msgstr "{0, plural, one {# miesiąc} two {# miesiące} few {# miesięcy} other {# miesięcy}}"

#: src/containers/Migrations/Migrations.tsx:3089
msgid "{megabytes} МБ"
msgstr "{megabytes} MB"

#: src/containers/Terminals/Terminal/DeviceState/RemainWater/RemainWater.tsx:38
msgid "{percentValue} - значение вычислено на основе продаж"
msgstr "{percentValue} - wartość obliczana na podstawie sprzedaży"

#: src/containers/Dashboard/BillingStats/columns.tsx:28
msgid "{value} из {Total}<0/> {percentFormatted}"
msgstr "{value} from {Total}<0/> {percentFormatted}"

#: src/locales/constants.ts:40
msgid "°"
msgstr "°"

#: src/locales/constants.ts:38
msgid "°C"
msgstr "°C"

#. placeholder {0}: formatMoney(data.intermediateValues?.expensesRental, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:280
msgid "+ {0} [аренда]"
msgstr "+ {0} [wynajem]"

#. placeholder {0}: formatMoney(bankAndTaxation, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:323
msgid "+ {0} [банк и налогообложение]"
msgstr "+ {0} [bank i opodatkowanie]"

#. placeholder {0}: formatMoney(sales.Bankcard || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:174
msgid "+ {0} [банк. карта]"
msgstr "+ {0} [karta bankowa]"

#. placeholder {0}: formatMoney(sales.Banknotes || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:172
msgid "+ {0} [банкноты]"
msgstr "+ {0} [banknoty]"

#. placeholder {0}: formatMoney(waterTotalExpenses, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:287
msgid "+ {0} [вода]"
msgstr "+ {0} [woda]"

#. placeholder {0}: formatMoney( data.intermediateValues?.incomeAdvertising || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:250
msgid "+ {0} [доходы от рекламы]"
msgstr "+ {0} [przychody z reklamy]"

#. placeholder {0}: formatMoney(sales.MobileApp || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:176
msgid "+ {0} [моб. приложение]"
msgstr "+ {0} [aplikacja mobilna]"

#. placeholder {0}: formatMoney(sales.Coins || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:173
msgid "+ {0} [монеты]"
msgstr "+ {0} [monety]"

#. placeholder {0}: formatMoney(pointMaintenance, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:298
msgid "+ {0} [обслуживание точки]"
msgstr "+ {0} [obsługa punktu]"

#. placeholder {0}: formatMoney(data.sales.Amount || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:248
msgid "+ {0} [продажи]"
msgstr "+ {0} [sprzedaż]"

#. placeholder {0}: formatMoney( data.intermediateValues?.incomeOtherSources || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:256
msgid "+ {0} [прочие доходы]"
msgstr "+ {0} [inne przychody]"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesOneTime || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:312
msgid "+ {0} [разовые расходы]"
msgstr "+ {0} [jednorazowe wydatki]"

#. placeholder {0}: formatMoney(cartridges, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:310
msgid "+ {0} [фильтры]"
msgstr "+ {0} [filtry]"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesElectricityPerKwH || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:289
msgid "+ {0} [электричество]"
msgstr "+ {0} [elektryczność]"

#: src/containers/OraclePage/ComputeTab/utils.ts:78
msgid "+ {money} [{kwH} кВт c {fromStr} по {toStr}, {moneyPerWat} за кВт]"
msgstr "+ {money} [{kwH} kW od {fromStr} do {toStr}, {moneyPerWat} za kW]"

#: src/containers/OraclePage/ComputeTab/utils.ts:54
msgid "+ {money} [{month} c {fromStr} по {toStr}, {moneyPerMonth} в месяц]"
msgstr "+ {money} [{month} od {fromStr} do {toStr}, {moneyPerMonth} miesięcznie]"

#: src/containers/OraclePage/ComputeTab/utils.ts:157
msgid "+ {negativeImpactCostPerM3} [Негативное воздействие, {negativeImpactCost} за м3]"
msgstr "+ {negativeImpactCostPerM3} [Negatywny wpływ, {negativeImpactCost} za m3]"

#: src/containers/OraclePage/ComputeTab/utils.ts:146
msgid "+ {wasteWaterCostPerM3} [Водоотведение, {wasteWaterCost} за м3]"
msgstr "+ {wasteWaterCostPerM3} [Odprowadzanie ścieków, {wasteWaterCost} za m3]"

#: src/containers/OraclePage/ComputeTab/utils.ts:136
msgid "+ {waterCostPerM3} [ХВС, {waterCost} за м3]"
msgstr "+ {waterCostPerM3} [Woda zimna, {waterCost} za m3]"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:90
msgid "<0> Аппарат <1>{deviceAddress}</1> будет удален безвозвратно.</0><2>Продолжить?</2>"
msgstr "<0> Urządzenie <1> {deviceAddress}</1> zostanie trwale usunięte.</0> <2>kontynuować?</2>"

#. placeholder {0}: SUPPORT_LINKS.TG
#. placeholder {1}: SUPPORT_LINKS.Tell
#: src/containers/Login/LoginForm.tsx:120
msgid "<0>Для получения аккаунта в системе GSM мониторинга вам необходимо обратиться в службу технической поддержки по следующим каналам:</0><1><2>{0}</2></1><3><4>{1}</4></3><5>Техническая поддержка работает ежедневно, с 7:00 до 21:00 по Московскому времени. Оформление доступа в личный кабинет происходит <6>ТОЛЬКО</6> через переписку!</5>"
msgstr "<0>Aby uzyskać konto w systemie monitoringu GSM, należy skontaktować się z działem pomocy technicznej poprzez następujące kanały:</0><1><2>{0}</2></1><3><4>{1}</4></3><5>Pomoc techniczna działa codziennie od 7:00 do 21:00 czasu moskiewskiego. Dostęp do konta osobistego jest udzielany <6>TYLKO</6> poprzez korespondencję!</5>"

#: src/containers/Services/Recharge.tsx:118
msgid "<0>Нажимая на кнопку <1>Пополнить</1>, вы соглашаетесь с условиями <2>Оферты</2></0><3>Если вам необходимы отчетные документы по оказанным услугам (акт оказанных услуг и счет-фактура), просим оплату проводить платежным поручением с расчетного счета юридического лица, на указанные ниже реквизиты:<4>ИП Вяткин Вячеслав Владимирович ИНН 591600372797 Р/с <5/>40802810049770036699 в ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК БИК<6/>042202603, к/с 30101810900000000603 Назначение платежа: \"4GSM Оплата информационного взаимодействия\"<7/></4><8>Для корректного зачисления платежа необходимо в профиле кабинета заполнить поле \"Налоговый идентификатор\"</8>При оплате банковской картой на сайте отчетные документы на реквизиты юридического лица предоставляться не будут.</3><9>Минимальная сумма платежа - {minPaymentSum}₽<10/>Максимальная сумма платежа - {maxPaymentSum}₽</9>"
msgstr "<0>Klikając przycisk <1>Doładuj</1>, zgadzasz się z warunkami <2>Oferty</2></0><3>Jeśli potrzebujesz dokumentów sprawozdawczych za świadczone usługi (zaświadczenie o świadczonych usługach i faktura), dokonaj płatności poleceniem zapłaty z rachunku bieżącego osoby prawnej na podane poniżej dane:<4>ИП Вяткин Вячеслав Владимирович ИНН 591600372797 Р/с <5/>40802810049770036699 в ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК БИК<6/>042202603, к/с 30101810900000000603 Назначение платежа: \"4GSM Оплата информационного взаимодействия\"<7/></4><8>Aby prawidłowo zaksięgować płatność, konieczne jest wypełnienie pola profilu konta \"BIN\"</8>W przypadku płatności kartą bankową na stronie internetowej nie będą udostępniane dokumenty sprawozdawcze dotyczące danych osoby prawnej.</3><9>Minimalna kwota płatności - {minPaymentSum}₽<10/>Maksymalna kwota płatności - {maxPaymentSum}₽</9>"

#: src/containers/Services/Recharge.tsx:178
msgid "<0>Обращаем ваше внимание, что денежные средства с вашей карты будут списаны в {currency}.  Сумма к списанию составляет <1>{formattedAmount}</1></0><2>Уважаемые клиенты компании \"Живая вода\".<3/>Хотим Вас проинформировать, что в связи с изменениями условий в одностороннем порядке банком партнером, с 01.08.2023 минимально возможная сумма для оплаты услуг GSM мониторинга составит в эквиваленте местной валюты 13 $<4/>Увеличение минимальной суммы платежа в 13 $ позволит Вам избежать комиссии банка в размере 1 $ с каждой оплаты.<5/>Наша Компания приложит все усилия над поиском альтернативных вариантов приема платежей по картам, эмитированным банками не резидентами РФ, в привычном Вам формате<6/></2>"
msgstr "<0>Pamiętaj, że środki zostaną pobrane z Twojej karty w {currency}.  Kwota do odpisania wynosi <1>{formattedAmount}</1></0><2>Szanowni klienci firmy \"Zhivaya Voda\".<3/>Informujemy, że w związku z jednostronną zmianą warunków przez bank partnerski, od 01.08.2023 r. minimalna możliwa kwota płatności za usługi monitoringu GSM wyniesie 13 USD w równowartości w walucie lokalnej<4/>Podniesienie minimalnej kwoty płatności do 13 USD pozwoli uniknąć prowizji bankowej w wysokości 1 USD za każdą płatność.<5/>Nasza firma dołoży wszelkich starań, aby znaleźć alternatywne opcje przyjmowania płatności kartami wydanymi przez banki, które nie są rezydentami Federacji Rosyjskiej, w formacie, do którego jesteście Państwo przyzwyczajeni<6/></2>"

#: src/containers/Terminals/NewDevice/CreateNotAvailable.tsx:6
msgid "<0>С 30.05.202 для России и 01.10.2022 для других стран, операции, связанные добавлением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для добавления оборудования вам необходимо указать следующую информацию:<6><7>логин к которому добавляется оборудование и наименование компании (так, как это указано в мониторинге)</7><8>IMEI аппарата</8><9>тип оборудования (доочистка или привозная)</9><10>номер симкарты, установленный в аппарате в формате +код страны</10><11>номер телефона (для России +7хххххххххх)</11><12>часовой пояс аппарата</12><13>валюта аппарата </13><14>телефон технической поддержки в формате + код страны</14><15>номер телефона (для России +7хххххххххх)</15><16>адрес установки аппарата в формате город, улица номер дома (строения)</16><17> стоимость воды за 1 л за наличные</17><18>стоимость воды за 1 л по IC карте</18></6></5>"
msgstr "<0>Od 30.05.2022 dla Rosji i 01.10.2022 dla innych krajów, operacje związane z dodawaniem sprzętu będą dostępne tylko poprzez pracowników pomocy technicznej.</0><1>Z pomocą techniczną można się skontaktować:<2><3>telegram <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Aby dodać sprzęt, należy podać następujące informacje:<6><7>login, do którego dodawany jest sprzęt i nazwa firmy (tak jak podano w monitoringu)</7><8>IMEI urządzenia</8><9>typ sprzętu (dodatkowa oczyszczalnia lub importowany)</9><10>numer karty SIM zainstalowanej w urządzeniu w formacie +kod kraju</10><11>numer telefonu (dla Rosji +7хххххххххх)</11><12>strefa czasowa urządzenia</12><13>waluta urządzenia </13><14>telefon pomocy technicznej w formacie +kod kraju</14><15>numer telefonu (dla Rosji +7хххххххххх)</15><16>adres instalacji urządzenia w formacie miasto, ulica numer domu (budynek)</16><17>koszt wody za 1 litr gotówką</17><18>koszt wody za 1 litr kartą IC</18></6></5>"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:100
msgid "<0>С 30.05.2022 операции, связанные удалением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для удаления аппарата необходимо указать следующую информацию:<6><7>логин у которого удаляется аппарат</7><8>наименование компании (так, как это указано в мониторинге)</8><9>IMEI удаляемого аппарата</9><10>причина удаления аппарата</10></6></5>"
msgstr "<0>Od 30.05.2022 operacje związane z usuwaniem sprzętu będą dostępne tylko poprzez pracowników pomocy technicznej.</0><1>Z pomocą techniczną można się skontaktować:<2><3>telegram <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Aby usunąć urządzenie, należy podać następujące informacje:<6><7>login, z którego usuwane jest urządzenie</7><8>nazwa firmy (tak jak podano w monitoringu)</8><9>IMEI usuwanego urządzenia</9><10>powód usunięcia urządzenia</10></6></5>"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:45
msgid "<0>Уважаемые пользователи GSM мониторинга!</0><1>Что бы избежать возможных сложностей при оплате услуг GSM мониторинга в начале месяца, настоятельно рекомендуем сделать очередной платеж за GSM мониторинг не позднее 25го числа текущего месяца.</1><2>Это позволит оперативно разобраться в проблеме, если она возникнет во время оплаты, и минимизировать время недоступности мониторинга для вас</2>"
msgstr "<0>Drodzy użytkownicy monitoringu GSM!</0><1>Aby uniknąć możliwych trudności przy opłacie usług monitoringu GSM na początku miesiąca, zdecydowanie zalecamy wykonanie kolejnej płatności za monitoring GSM najpóźniej do 25. dnia bieżącego miesiąca.</1><2>Pozwoli to szybko rozwiązać problem, jeśli wystąpi on podczas płatności, i zminimalizować czas niedostępności monitoringu dla Państwa.</2>"

#: src/components/ServiceNotificationModal.tsx:40
msgid "<0>Что это означает простыми словами?</0><1><2>Доступ к мониторингу платный и составляет <3>200 руб</3> за один аппарат в месяц. Метод расчетов - авансовый. Списание средств с баланса будет происходить первого числа ежемесячно в размере 200 руб * число аппаратов, зарегистрированных в мониторинге на дату списания.</2></1><4>В случае, если средств на балансе не хватает на все оборудование, доступ к личному кабинету будет приостановлен до пополнения баланса. Все описанное выше распространяется на оборудование, зарегистрированное в мониторинге до 06.2021.</4><5><6>При регистрации нового оборудования на ваш баланс будет начислена сумма 200 руб на каждую единицу оборудования</6><7>Операции связанные с добавлением и удалением оборудования с 01.06.2022 будут производиться ТОЛЬКО через службу технической поддержки.</7><8>Возможность принимать платежи через приложение и/или через QR код так же становится платной. Оплата составляет 100 руб/мес. Данную услугу вы можете самостоятельно подключить/отключить в мониторинге.</8></5><9>Первое списание денежных средств с баланса произойдёт 01.07.2022. До этого момента настоятельно рекомендуем вам пополнить ваш баланс в личном кабинете.</9>"
msgstr "<0>Co to oznacza w prostych słowach?</0><1><2>Dostęp do monitoringu jest płatny i wynosi <3>200 rubli</3> za jedno urządzenie miesięcznie. Metoda rozliczeń - z góry. Środki będą pobierane z konta pierwszego dnia każdego miesiąca w wysokości 200 rubli * liczba urządzeń zarejestrowanych w monitoringu w dniu pobrania.</2></1><4>W przypadku, gdy środków na koncie nie wystarczy na wszystkie urządzenia, dostęp do konta osobistego zostanie wstrzymany do czasu uzupełnienia salda. Wszystko powyższe dotyczy sprzętu zarejestrowanego w monitoringu przed 06.2021.</4><5><6>Przy rejestracji nowego sprzętu na Twoje konto zostanie naliczona kwota 200 rubli za każdą jednostkę sprzętu</6><7>Operacje związane z dodawaniem i usuwaniem sprzętu od 01.06.2022 będą wykonywane TYLKO poprzez dział pomocy technicznej.</7><8>Możliwość przyjmowania płatności poprzez aplikację i/lub kod QR również staje się płatna. Opłata wynosi 100 rubli/miesiąc. Tę usługę możesz samodzielnie włączyć/wyłączyć w monitoringu.</8></5><9>Pierwsze pobranie środków z konta nastąpi 01.07.2022. Do tego czasu zdecydowanie zalecamy uzupełnienie salda na koncie osobistym.</9>"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:32
msgid "<0>Что это означает простыми словами?</0><1><2>У аппарата одна общая система водоподготовки и две камеры розлива, каждая из которых имеет свою плату управления. В системе мониторинга такой аппарат технически воспринимается как два отдельных устройства. Однако для удобства их данные иногда объединяются в одном интерфейсе.</2><3>Устройство с подключенной системой водоподготовки называют ГЛАВНЫМ, а второе, без собственной системы, — ВТОРИЧНЫМ.</3><4>Чтобы жизнь стала проще, изменения настроек платы управления главного устройства автоматически копирутся на вторичное. Но если нужно, настройки вторичного устройства можно скорректировать вручную.</4></1><5>Идея проста: Объединять такие аппараты в единое устройство там, где это удобно, и разделять их на два независимых элемента, когда это необходимо.</5>"
msgstr "<0>Co to oznacza w prostych słowach?</0><1><2>Urządzenie ma jeden wspólny system przygotowania wody i dwie komory napełniania, z których każda ma własną płytę sterującą. W systemie monitoringu takie urządzenie jest technicznie postrzegane jako dwa oddzielne urządzenia. Jednak dla wygody ich dane są czasami łączone w jednym interfejsie.</2><3>Urządzenie z podłączonym systemem przygotowania wody nazywa się GŁÓWNYM, a drugie, bez własnego systemu, nazywa się WTÓRNYM.</3><4>Aby ułatwić życie, zmiany w ustawieniach płyty sterującej urządzenia głównego są automatycznie kopiowane na urządzenie wtórne. Ale jeśli to konieczne, ustawienia urządzenia wtórnego można dostosować ręcznie.</4></1><5>Pomysł jest prosty: Łączyć takie urządzenia w jedno tam, gdzie jest to wygodne, i rozdzielać je na dwa niezależne elementy, gdy jest to konieczne.</5>"

#: src/containers/Terminals/EditDevice/BundleDeviceAdmin.tsx:206
msgid "<0>Это вторичное устройство. Редактируйте его на странице главного:</0><1><2>Перейти к главному устройству</2></1>"
msgstr "<0>To jest urządzenie wtórne. Edytuj je na stronie głównego:</0><1><2>Przejdź do urządzenia głównego</2></1>"

#: src/containers/Migrations/Migrations.tsx:315
msgid "<1с"
msgstr "<1s"

#. placeholder {0}: formatMoney(acc, currency)
#. placeholder {0}: formatMoney(total, currency)
#. placeholder {0}: formatMoney(sales.Amount || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:57
#: src/containers/OraclePage/ComputeTab/utils.ts:85
#: src/containers/OraclePage/ComputeTab/utils.ts:112
#: src/containers/OraclePage/ComputeTab/utils.ts:163
#: src/containers/OraclePage/ComputeTab/utils.ts:179
#: src/containers/OraclePage/ComputeTab/utils.ts:261
#: src/containers/OraclePage/ComputeTab/utils.ts:325
#: src/containers/OraclePage/ComputeTab/utils.ts:433
#: src/containers/OraclePage/ComputeTab/utils.ts:453
msgid "= {0}"
msgstr "= {0}"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesTax || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:491
msgid "= {0} налог"
msgstr "= {0} podatek"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:33
msgid "100 мл"
msgstr "100 ml"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:41
msgid "30 мл"
msgstr "30 ml"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:184
msgid "4x строчный"
msgstr "4x linia"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:186
msgid "4x строчный и отображаются 10 доли"
msgstr "4x linia i wyświetlane są 10 części"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:37
msgid "50 мл"
msgstr "50 ml"

#: src/containers/Dashboard/AllMoney/utils.ts:42
msgid "App/Qr"
msgstr "App/Qr"

#: src/locales/constants.ts:37
msgid "c."
msgstr "с."

#: src/config/menu.tsx:30
msgid "Dashboard"
msgstr "Dashboard"

#: src/locales/constants.ts:45
msgid "Email"
msgstr "Email"

#: src/containers/Migrations/Migrations.tsx:2467
msgid "EWMA стоимости страницы"
msgstr "EWMA kosztu strony"

#: src/locales/constants.ts:12
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:67
#: src/containers/DeviceList/columns/desktop.tsx:62
msgid "IMEI"
msgstr "IMEI"

#: src/hooks/useTempreatureFormatter.ts:9
msgid "N/A"
msgstr "N/A"

#: src/containers/Migrations/Migrations.tsx:624
#: src/containers/Migrations/Migrations.tsx:873
msgid "Parquet, МБ (telemetry 6 мес., оценка)"
msgstr "Parquet, MB (telemetria z 6 mies., szacunek)"

#: src/containers/Migrations/Migrations.tsx:2680
msgid "Parquet, МБ (telemetry 6 мес., суммарная оценка)"
msgstr "Parquet, MB (telemetria z 6 mies., łączny szacunek)"

#: src/containers/Migrations/Migrations.tsx:600
#: src/containers/Migrations/Migrations.tsx:849
msgid "Parquet, МБ (всё, оценка)"
msgstr "Parquet, MB (wszystkie dane, szacunek)"

#: src/containers/Migrations/Migrations.tsx:2671
msgid "Parquet, МБ (всё, суммарная оценка)"
msgstr "Parquet, MB (wszystkie dane, łączny szacunek)"

#: src/containers/Migrations/Migrations.tsx:2393
msgid "Pod"
msgstr "Pod"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:86
msgid "Portal и worker вернутся к штатной обработке."
msgstr "Portal i workery powrócą do normalnego działania."

#: src/containers/Migrations/Migrations.tsx:630
#: src/containers/Migrations/Migrations.tsx:879
msgid "PostgreSQL, МБ (telemetry 6 мес., оценка)"
msgstr "PostgreSQL, MB (telemetria z 6 mies., szacunek)"

#: src/containers/Migrations/Migrations.tsx:2690
msgid "PostgreSQL, МБ (telemetry 6 мес., суммарная оценка)"
msgstr "PostgreSQL, MB (telemetria z 6 mies., łączny szacunek)"

#: src/containers/Migrations/Migrations.tsx:606
#: src/containers/Migrations/Migrations.tsx:855
msgid "PostgreSQL, МБ (всё, оценка)"
msgstr "PostgreSQL, MB (wszystkie dane, szacunek)"

#: src/containers/Migrations/Migrations.tsx:2675
msgid "PostgreSQL, МБ (всё, суммарная оценка)"
msgstr "PostgreSQL, MB (wszystkie dane, łączny szacunek)"

#: src/locales/constants.ts:34
#: src/containers/DeviceList/columns/mobile.tsx:91
msgid "ppm"
msgstr "ppm"

#: src/components/ConnectBot/ConnectBot.tsx:166
msgid "Telegram пользователь успешно отвязан"
msgstr "Użytkownik Telegram został pomyślnie odłączony"

#: src/containers/Migrations/Migrations.tsx:618
#: src/containers/Migrations/Migrations.tsx:867
msgid "Telemetry mono за 6 месяцев"
msgstr "Telemetria mono za 6 miesięcy"

#: src/containers/Migrations/Migrations.tsx:612
#: src/containers/Migrations/Migrations.tsx:861
msgid "Telemetry за 6 месяцев"
msgstr "Telemetria za 6 miesięcy"

#: src/containers/Migrations/Migrations.tsx:2472
msgid "Throttling DynamoDB"
msgstr "Ograniczanie przepustowości DynamoDB"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:26
msgid "Wi-Fi"
msgstr "Wi-Fi"

#: src/containers/Migrations/Migrations.tsx:2634
msgid "Автообновление каждые 20 секунд"
msgstr "Automatyczne odświeżanie co 20 sekund"

#: src/containers/Migrations/Migrations.tsx:2491
msgid "Автообновление каждые 5 секунд"
msgstr "Automatyczne odświeżanie co 5 sekund"

#: src/locales/constants.ts:5
#: src/containers/Encash/useEncashColumns.tsx:78
#: src/containers/DeviceList/columns/base.tsx:35
msgid "Адрес"
msgstr "Adres"

#: src/locales/constants.ts:4
msgid "Адрес установки аппарата"
msgstr "Adres instalacji urządzenia"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:128
msgid "Активация аппарата прошла успешно"
msgstr "Aktywacja urządzenia przebiegła pomyślnie"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:172
msgid "Активировать аппарат"
msgstr "Aktywuj urządzenie"

#: src/containers/Migrations/Migrations.tsx:2454
msgid "Активные Query"
msgstr "Aktywne zapytania"

#: src/containers/Dashboard/Users/Users.tsx:75
msgid "Активные за последние 2 месяца"
msgstr "Aktywni w ciągu ostatnich 2 miesięcy"

#: src/containers/Dashboard/Users/Users.tsx:86
msgid "Активные за последние 2 месяца по группам"
msgstr "Aktywni w ciągu ostatnich 2 miesięcy według grup"

#: src/containers/Dashboard/Users/Users.tsx:57
msgid "Активных за последние 2 месяца"
msgstr "Aktywnych w ciągu ostatnich 2 miesięcy"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:61
msgid "Акция"
msgstr "Promocja"

#: src/containers/Terminals/Terminal/Device.tsx:122
msgid "Аналитика"
msgstr "Analityk"

#: src/features/deviceAlerts/i18n/translations.ts:8
msgid "Аппарат давно не выходил на связь. Возможно, с ним есть определенные проблемы"
msgstr "Urządzenie długo nie nawiązywało połączenia. Mogą wystąpić pewne problemy"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:80
msgid "Аппарат обновлен"
msgstr "Urządzenie zostało zaktualizowane"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:26
msgid "Аппарат с двумя камерами розлива"
msgstr "Urządzenie z dwoma komorami napełniania"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:167
msgid "Аппарат требует активации службой технической поддержки"
msgstr "Urządzenie wymaga aktywacji przez pomoc techniczną"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:76
msgid "Аппарат удален"
msgstr "Urządzenie usunięte"

#. placeholder {0}: formatCount(Number(value))
#: src/containers/Migrations/Migrations.tsx:3012
msgid "Аппаратов: {0}"
msgstr "Urządzenia: {0}"

#: src/containers/Migrations/Migrations.tsx:814
#: src/containers/Migrations/Migrations.tsx:2867
#: src/containers/Dashboard/Dashboard.tsx:37
#: src/config/menu.tsx:54
#: src/components/Stats/UserDevices.tsx:85
msgid "Аппараты"
msgstr "Urządzenia"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:82
#: src/containers/Terminals/NewDevice/DeviceBaseFields.tsx:191
msgid "Архивная версия платформы"
msgstr "Archiwalna wersja platformy"

#: src/locales/constants.ts:36
msgid "атм"
msgstr "atm"

#: src/containers/Terminals/Terminal/Device.tsx:128
#: src/containers/DeviceList/constants.ts:27
msgid "Аудит"
msgstr "Audyt"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:105
#: src/containers/Services/Services.tsx:204
#: src/containers/Services/BalanceHistory.tsx:45
msgid "Баланс"
msgstr "Saldo"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:47
msgid "Безопасность"
msgstr "Bezpieczeństwo"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:20
msgid "Блокировка при открытой дверце"
msgstr "Blokada przy otwartych drzwiach"

#. placeholder {0}: DateTime.fromMillis(device?.DeviceState.UpdatedAt ?? 0).toFormat('t')
#. placeholder {1}: t('ui:units.liters_per_minute', { value })
#: src/containers/Terminals/Terminal/DeviceState/TerminalWaterPrepare.tsx:131
msgid "в {0} - {1}"
msgstr "o {0} - {1}"

#. placeholder {2}: DateTime.fromMillis(device?.DeviceState.UpdatedAt ?? 0).toFormat('t')
#. placeholder {3}: t('ui:units.liters_per_minute', { value })
#: src/containers/Terminals/Terminal/DeviceState/TerminalWaterPrepare.tsx:142
msgid "в {2} - {3}"
msgstr "o {2} - {3}"

#: src/features/deviceAlerts/i18n/translations.ts:12
msgid "В аппарате более 2 часов не было продаж. Возможно, с ним есть определенные проблемы"
msgstr "W urządzeniu nie było sprzedaży przez ponad 2 godziny. Mogą wystąpić pewne problemy"

#: src/containers/Encash/useEncashColumns.tsx:88
msgid "В купюрах"
msgstr "W banknotach"

#: src/containers/Encash/useEncashColumns.tsx:94
msgid "В монетах"
msgstr "W monetach"

#: src/containers/Users/UsersList.tsx:31
msgid "В сети"
msgstr "W sieci"

#: src/containers/Sales/SalesTotal.tsx:115
msgid "в том числе обогащенной воды <0>{otherWaterLitres} ({otherWaterLitersPercent})</0> на <1>{otherWaterAmount} ({otherWaterAmountPercent})</1>"
msgstr "korzeń w tym liczby są wzbogacone w. <0>{otherWaterLitres} ({otherWaterLitersPercent})</0> na <1>{otherWaterAmount} ({otherWaterAmountPercent})</1>"

#: src/locales/constants.ts:11
msgid "Валюта"
msgstr "Waluta"

#: src/hooks/useCheckBalance.ts:36
msgid "Вам необходимо пополнить баланс лицевого счета для бесперебойной работы системы GSM мониторинга"
msgstr "Musisz uzupełnić saldo konta osobistego, aby zapewnić bezproblemowe działanie systemu monitoringu GSM"

#: src/containers/OraclePage/EditDataTab/validationSchema.ts:12
msgid "Введите число"
msgstr "Wprowadź liczbę"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:76
msgid "Версия платы Водоподготовки"
msgstr "Wersja płyty uzdatniania wody"

#: src/containers/Update/Update.tsx:50
msgid "Версия прошивки"
msgstr "Wersja oprogramowania"

#: src/containers/Migrations/Migrations.tsx:2959
msgid "Визуализация"
msgstr "Wizualizacja"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:46
msgid "включена"
msgstr "włączona"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:87
msgid "Включить"
msgstr "Włącz"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:82
msgid "Включить технические работы?"
msgstr "Włączyć tryb prac technicznych?"

#: src/locales/constants.ts:19
#: src/locales/constants.ts:23
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:37
msgid "Владелец"
msgstr "Właściciel"

#: src/features/demoAccess/ui/DemoAccessHint.tsx:10
msgid "Внимание! Это демонстрационный аккаунт. <0>Все адреса и суммы продаж вымышлены, любые совпадения с реальными адресами случайны</0>"
msgstr "Uwaga! To jest konto demonstracyjne. <0> wszystkie adresy i kwoty sprzedaży są fikcyjne, wszelkie dopasowania do prawdziwych adresów są losowe</0>"

#: src/containers/DeviceList/columns/mobile.tsx:48
msgid "Вода"
msgstr "Woda"

#: src/containers/DeviceList/constants.ts:26
msgid "Вода+"
msgstr "Woda+"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:75
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:23
msgid "Водоподготовка"
msgstr "Uzdatnianie wody"

#: src/containers/Login/LoginForm.tsx:115
msgid "Войти"
msgstr "Zaloguj"

#: src/containers/Login/LoginForm.tsx:117
msgid "Восстановить"
msgstr "Odzyskaj"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:93
#: src/containers/Services/BalanceHistory.tsx:25
msgid "Время"
msgstr "Czas"

#: src/containers/Migrations/Migrations.tsx:1805
msgid "Время выполнения: {minutes} мин {seconds} сек"
msgstr "Czas wykonania: {minutes} min {seconds} s"

#: src/containers/Migrations/Migrations.tsx:1806
msgid "Время выполнения: {seconds} сек"
msgstr "Czas wykonania: {seconds} s"

#: src/containers/Migrations/Migrations.tsx:653
#: src/containers/Migrations/Migrations.tsx:903
msgid "Время миграции"
msgstr "Czas migracji"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:141
msgid "Время набора раствора для промывки в мембрану"
msgstr "Czas rekrutacji roztworu do płukania do membrany"

#: src/containers/Migrations/Migrations.tsx:636
#: src/containers/Migrations/Migrations.tsx:885
msgid "Время оценки"
msgstr "Czas szacowania"

#. placeholder {0}: data.firstSaleTs ? convertTimestampToLocalDateString(data.firstSaleTs) : 'нет продаж'
#: src/containers/OraclePage/ComputeTab/utils.ts:214
msgid "Время первой продажи: {0}"
msgstr "Czas pierwszej sprzedaży: {0}"

#: src/hooks/useGroupsOptions.tsx:13
msgid "Все группы"
msgstr "Wszyscy"

#: src/containers/Migrations/Migrations.tsx:3066
msgid "Все данные полностью"
msgstr "Wszystkie dane w całości"

#: src/containers/Migrations/Migrations.tsx:2617
msgid "Все размеры приблизительные. В варианте «telemetry 6 мес.» только telemetry и telemetry mono ограничены шестью месяцами, остальные данные учитываются полностью."
msgstr "Wszystkie rozmiary są przybliżone. W wariancie „telemetria z 6 mies.” tylko telemetry i telemetry mono są ograniczone do sześciu miesięcy; pozostałe dane są uwzględniane w całości."

#: src/containers/Encash/useEncashColumns.tsx:82
#: src/containers/DeviceList/columns/list.tsx:69
#: src/containers/Dashboard/AllMoney/utils.ts:29
#: src/containers/Dashboard/AllMoney/utils.ts:57
msgid "Всего"
msgstr "Razem"

#: src/containers/Migrations/Migrations.tsx:2659
#: src/containers/Dashboard/Devices/utils.ts:59
msgid "Всего аппаратов"
msgstr "Całkowita Aparatura"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:126
msgid "Всего в аппарате"
msgstr "Łącznie w aparacie"

#: src/containers/Sales/SalesTotal.tsx:103
msgid "Всего за период <0>{formattedTotal}{delimiter}{formattedLiters}{wats}{liters}</0>"
msgstr "W sumie za okres <0> {formattedTotal}{delimiter}{formattedLiters}{wats}{liters}</0>"

#: src/containers/Encash/Encash.tsx:70
msgid "Всего за период <0>{formattedTotal}</0>"
msgstr "W sumie za okres <0> {formattedTotal}</0>"

#: src/containers/Dashboard/Users/Users.tsx:70
msgid "Всего зарегистрированных"
msgstr "Wszystkich zarejestrowanych"

#: src/containers/Migrations/Migrations.tsx:2655
msgid "Всего пользователей"
msgstr "Łączna liczba użytkowników"

#: src/containers/Dashboard/Users/Users.tsx:49
msgid "Всего пользователей:"
msgstr "Wszystkich użytkowników:"

#: src/containers/Dashboard/BillingStats/columns.tsx:57
msgid "Всего счетов к обработке"
msgstr "Total bills"

#: src/containers/Dashboard/Geography/Geography.tsx:20
msgid "Всего устройств"
msgstr "Wszystkich urządzeń"

#: src/containers/KnowledgeBase/Section.tsx:42
msgid "Вся база знаний"
msgstr "All articles"

#. placeholder {0}: convertTimestampToLocalDateString( data.period.userFromTs )
#. placeholder {1}: convertTimestampToLocalDateString(data.period.userToTs)
#: src/containers/OraclePage/ComputeTab/utils.ts:222
msgid "Вы выбрали Период с {0} по {1}."
msgstr "Wybrałeś okres od {0} do {1}."

#: src/containers/Terminals/EditDevice/PromoField.tsx:15
msgid "Вы выключили режим Промоакция. Параметр Автостоп наличные/банк.карта установлен равным 0 литров"
msgstr "Wyłączyłeś tryb Promocja. Parametr AUTOSTOP jest ustawiony na 0 litrów."

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:93
msgid "Вы меняете показания: {metertLabel}"
msgstr "Zmieniasz odczyty: {metertLabel}"

#: src/containers/Encash/EncashComment.tsx:41
msgid "Вы можете добавить комментарий"
msgstr "Możesz dodać komentarz"

#: src/containers/Dashboard/BillingStats/BillingStats.tsx:38
msgid "Выберите месяц за который хотите получить отчет"
msgstr "Pick month for report"

#: src/locales/constants.ts:7
msgid "Выберите точный адрес установки из списка"
msgstr "Wybierz dokładny adres instalacji z listy"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:63
msgid "Выберите услугу"
msgstr "Seelect service"

#: src/components/LastServiceDate/LastServiceDate.tsx:152
msgid "Выбранная дата обслуживания установится для ВСЕХ аппаратов в личном кабинете"
msgstr "Wybrana data serwisowa zostanie ustawiona dla wszystkich urządzeń na koncie osobistym"

#: src/containers/Migrations/Migrations.tsx:955
msgid "Выгружает полную историю в Parquet, импортирует её в PostgreSQL и сохраняет резервную копию в MinIO"
msgstr "Eksportuje pełną historię do Parquet, importuje ją do PostgreSQL i zapisuje kopię zapasową w MinIO"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:97
msgid "Выгрузить ручные корректировки"
msgstr "Pobierz ręczne korekty"

#: src/containers/Migrations/Migrations.tsx:1088
msgid "Выгрузка истории из DynamoDB"
msgstr "Eksportowanie historii z DynamoDB"

#: src/containers/Migrations/Migrations.tsx:1086
msgid "Выгрузка текущего состояния из DynamoDB"
msgstr "Eksportowanie bieżącego stanu z DynamoDB"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:50
msgid "выключена"
msgstr "wyłączona"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:30
msgid "Выключено"
msgstr "Wyłączone"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:87
msgid "Выключить"
msgstr "Wyłącz"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:83
msgid "Выключить технические работы?"
msgstr "Wyłączyć tryb prac technicznych?"

#: src/containers/Migrations/Migrations.tsx:227
#: src/containers/Migrations/Migrations.tsx:244
#: src/containers/Migrations/Migrations.tsx:1046
#: src/containers/Migrations/Migrations.tsx:2369
msgid "Выполняется"
msgstr "W toku"

#: src/containers/Migrations/Migrations.tsx:1057
msgid "Выполняется для"
msgstr "Wykonywane dla"

#: src/containers/Sales/Sales.tsx:145
msgid "Выслать общий отчет"
msgstr "Wyślij ogólny raport"

#: src/containers/Sales/Sales.tsx:138
msgid "Выслать отчет о продажах"
msgstr "Wyślij raport sprzedaży"

#: src/containers/Dashboard/AllMoney/utils.ts:19
msgid "Гарантийное оборудование"
msgstr "Sprzęt gwarancyjny"

#: src/containers/Dashboard/Dashboard.tsx:31
msgid "География"
msgstr "Geografia"

#: src/config/menu.tsx:36
msgid "Главная"
msgstr "Główny"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:156
msgid "Голосовой помощник"
msgstr "Asystent głosowy"

#: src/locales/constants.ts:49
msgid "Группа"
msgstr "Zespół"

#: src/containers/Dashboard/Devices/Devices.tsx:41
#: src/containers/Dashboard/AllMoney/AllMoney.tsx:80
msgid "Группа:"
msgstr "Grupa:"

#: src/config/menu.tsx:48
msgid "Группы пользователей"
msgstr "Grupy użytkowników"

#: src/ui-kit/Form/Switch/Switch.tsx:138
#: src/components/Switch.tsx:80
msgid "Да"
msgstr "Tak"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:113
msgid "Данные"
msgstr "Dane"

#: src/utils/http.ts:22
msgid "Данные не доступны в демо-режиме"
msgstr "Dane nie są dostępne w trybie demo"

#: src/containers/Staff/StaffForm.tsx:35
msgid "Данные о сотруднике обновлены"
msgstr "Dane pracownika zaktualizowane"

#: src/containers/Staff/StaffForm.tsx:57
msgid "Данные о сотруднике удалены"
msgstr "Dane pracownika usunięte"

#: src/containers/Encash/useEncashColumns.tsx:104
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:10
msgid "Дата"
msgstr "Data"

#: src/locales/constants.ts:14
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:49
#: src/containers/Terminals/EditDevice/EditDevice.tsx:162
msgid "Дата обслуживания"
msgstr "Data usługi"

#: src/components/LastServiceDate/LastServiceDate.tsx:106
msgid "Дата последнего обслуживания обновлена"
msgstr "Data ostatniej aktualizacji usługi"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:121
msgid "Датчик столба жидкости"
msgstr "Czujnik słupa cieczy\""

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:68
msgid "Датчики"
msgstr "Czujnik"

#: src/containers/OraclePage/EditDataTab/validationSchema.ts:21
msgid "Даты не должны быть одинаковыми"
msgstr "Daty nie powinny być takie same"

#: src/containers/DeviceList/columns/base.tsx:44
msgid "двухкамерный"
msgstr "dwukomorowy"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:180
#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:94
msgid "двухстрочный"
msgstr "dwulinijkowy"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:182
msgid "двухстрочный моргающий"
msgstr "dwulinijkowy migający"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:98
msgid "двухстрочный по очереди"
msgstr "dwulinijkowy naprzemiennie"

#: src/containers/Migrations/Migrations.tsx:529
#: src/containers/Migrations/Migrations.tsx:730
#: src/containers/Migrations/Migrations.tsx:2795
msgid "Действия"
msgstr "Akcje"

#: src/components/Stats/constants.ts:11
msgid "День"
msgstr "Dzień"

#: src/containers/DeviceList/constants.ts:23
#: src/containers/DeviceList/columns/mobile.tsx:143
#: src/containers/DeviceList/columns/desktop.tsx:143
#: src/containers/Dashboard/Dashboard.tsx:25
#: src/components/Stats/constants.ts:17
msgid "Деньги"
msgstr "Pieniądze"

#: src/containers/Migrations/Migrations.tsx:2613
msgid "Детали миграции"
msgstr "Szczegóły migracji"

#: src/containers/Dashboard/Dashboard.tsx:28
msgid "Динамика билинга"
msgstr "Billing dynamics"

#: src/containers/DeviceList/constants.ts:28
msgid "Динамика продаж"
msgstr "Sales dynamic"

#: src/containers/Migrations/Migrations.tsx:2432
msgid "Диск pod: свободно / всего"
msgstr "Dysk poda: wolne / łącznie"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:120
msgid "Диффузионная промывка"
msgstr "Płukanie dyfuzyjne"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:140
msgid "Длительность набора состава сек"
msgstr "Czas trwania składu sek"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:148
msgid "Длительность промывки ХВС {tflUnit}"
msgstr "Czas płukania zimnej wody {tflUnit}"

#: src/containers/Login/LoginForm.tsx:109
msgid "Для demo-доступа используйте <0>demo</0> в качестве логина и любой пароль"
msgstr "Aby uzyskać dostęp demo, użyj<0>demo</0> jako loginu i dowolnego hasła"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:69
msgid "Для аппарата на дату {SunCalcDate} время рассвета:{SunCalcSunrise}, время заката: {SunCalcSunset} (выкл/вкл подсветки произойдет в течение часа после рассвета/заката, соответственно)"
msgstr "Dla urządzenia na dzień {SunCalcDate} czas wschodu słońca: {SunCalcSunrise}, czas zachodu słońca: {SunCalcSunset} (wyłączenie/włączenie podświetlenia nastąpi w ciągu godziny po wschodzie/zachodzie słońca, odpowiednio)"

#: src/containers/Services/Services.tsx:251
msgid "Для вас нет доступных услуг"
msgstr "Nie masz dostępnych usług"

#: src/containers/Staff/Staff.tsx:38
msgid "Для добавления, изменения, удаления данных о сотрудниках необходимо обратиться в техническую поддержку телеграмм <0>@alivewaternewbot</0>"
msgstr "Aby dodać, zmienić, usunąć dane pracowników, należy skontaktować się z Pomocą techniczną telegramu <0>@alivewaternewbot</0 >"

#: src/features/deviceAlerts/i18n/translations.ts:20
msgid "Для корректной работы оборудования вам необходимо его перезагрузить"
msgstr "Aby urządzenie działało poprawnie, należy je zrestartować"

#: src/containers/Services/Services.tsx:113
msgid "Для отображения данных, на балансе лицевого счета недостаточно средств"
msgstr "Aby wyświetlić dane, na koncie osobistym nie ma wystarczających środków"

#: src/containers/OraclePage/EditDataTab/OracleHistoryInput/HistoryDataForm/HistoryDataForm.tsx:126
msgid "Добавить новую запись"
msgstr "Dodaj nowy wpis"

#: src/containers/Staff/Staff.tsx:33
msgid "Добавить сотрудника"
msgstr "Dodaj pracownika"

#: src/containers/Migrations/Migrations.tsx:2889
msgid "Добавлено аппаратов: {addedDeviceCount}"
msgstr "Dodano urządzenia: {addedDeviceCount}"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:178
msgid "Добавлено в PostgreSQL"
msgstr "Dodano w PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:2760
msgid "Добавлено пользователей: {synchronizedCount}"
msgstr "Dodano użytkowników: {synchronizedCount}"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:110
msgid "Добро пожаловать"
msgstr "Witamy"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:114
msgid "Добро пожаловать + номер техподдержки"
msgstr "Witamy + numer pomocy technicznej"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:76
msgid "Добро пожаловать в 1 строке и номер техподдержки в 3-4 строках"
msgstr "Witamy w 1 linii i numer wsparcia technicznego w 3-4 liniach"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:68
msgid "Добро пожаловать в 1 строке."
msgstr "Witamy w 1 linii."

#: src/locales/constants.ts:22
msgid "Долгота"
msgstr "Długość geograficzna"

#: src/config/menu.tsx:79
msgid "Домашние системы очистки"
msgstr "Domowe systemy czyszczące"

#: src/locales/constants.ts:46
msgid "Дополнительно высылать отчеты на следующие адреса"
msgstr "Dodatkowo Wyślij raporty na następujące adresy"

#: src/components/ServiceNotificationModal.tsx:34
msgid "Доступ к GSM мониторингу предоставляется на платной основе"
msgstr "Dostęp do monitoringu GSM jest płatny"

#: src/containers/DeviceList/DeviceList.tsx:178
msgid "Доступно только для оборудования с оригинальной платой водоподготовки Живая вода"
msgstr "Dostępne tylko dla urządzeń z oryginalną płytą uzdatniania wody Wodomat"

#: src/containers/Dashboard/AllMoney/utils.ts:52
msgid "Другие"
msgstr "Inne"

#: src/components/CartridgeValue/EditValueModal.tsx:158
msgid "Если вы заменили счетчик ХВС - нажмите на эту кнопку. Это важно чтобы корректно рассчитать ОСТАЛОСЬ ДО ЗАМЕНЫ у картриджей 1-3 ступеней очистки"
msgstr "Jeśli wymieniłeś licznik zimnej wody, naciśnij ten przycisk. To ważne, aby prawidłowo obliczyć POZOSTAŁO DO WYMIANY wkładów filtracyjnych 1–3 stopnia."

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:108
msgid "Живая вода"
msgstr "Wodomat"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:64
msgid "Живая вода в 1 строке"
msgstr "Wodomat w 1 linii"

#. placeholder {0}: DateTime.fromMillis(Number(date)) .setLocale('ru-ru') .toFormat('dd-MM-yyyy')
#: src/containers/Report/Report.tsx:57
msgid "за {0}"
msgstr "za {0}"

#: src/containers/Services/Services.tsx:185
msgid "За каждую ДСО, указанную на данной вкладке, удерживается {hwtPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ - ДСО."
msgstr "Dla każdego DSC określonego na tej karcie pobierana jest opłata {hwtPrice} miesięcznie za usługę MONITORINGU GPS STEROWANIA PARAMETRAMI URZĄDZENIA - DSC."

#: src/containers/Services/Services.tsx:173
msgid "За каждый аппарат, указанный на данной вкладке, удерживается {moniProPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ. Если у вас нет необходимости в использовании этого сервиса для конкретного аппарата - вам необходимо удалить аппарат из системы. Для удаления - обратитесь в службу технической поддержки."
msgstr "Za każde urządzenie wymienione na tej karcie pobierana jest opłata {moniProPrice} miesięcznie za usługę MONITORINGU GPS, polegającą na monitorowaniu parametrów sprzętu. Jeśli nie potrzebujesz tej usługi na konkretnym urządzeniu, musisz usunąć urządzenie z systemu. Aby usunąć, skontaktuj się z pomocą techniczną."

#: src/containers/OraclePage/ComputeTab/utils.ts:237
msgid "За это время не было продаж и расходов (расходы считаются только там где есть продажи):"
msgstr "W tym czasie nie było sprzedaży i wydatków (wydatki są liczone tylko tam, gdzie są sprzedaże):"

#: src/containers/OraclePage/ComputeTab/utils.ts:234
msgid "За это время:"
msgstr "W tym czasie:"

#: src/containers/Users/UserMenu.tsx:164
#: src/containers/Users/UserMenu.tsx:215
msgid "Заблокировать"
msgstr "Zablokować"

#: src/containers/Users/UserMenu.tsx:163
msgid "Заблокировать пользователя?"
msgstr "Zablokować użytkownika?"

#: src/containers/Migrations/Migrations.tsx:228
#: src/containers/Migrations/Migrations.tsx:245
msgid "Завершена"
msgstr "Zakończona"

#: src/containers/Migrations/Migrations.tsx:1104
msgid "Завершение миграции"
msgstr "Finalizowanie migracji"

#: src/containers/Migrations/Migrations.tsx:1096
msgid "Загрузка истории в PostgreSQL"
msgstr "Ładowanie historii do PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:1090
msgid "Загрузка текущего состояния в PostgreSQL"
msgstr "Ładowanie bieżącego stanu do PostgreSQL"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:96
#: src/components/Stats/UserDevices.tsx:93
msgid "Загрузка..."
msgstr "Ładowanie..."

#: src/features/deviceAlerts/i18n/translations.ts:9
msgid "Закончилась вода в баке. Возможно, отключен водопровод или имеются другие проблемы с аппаратом"
msgstr "Zabrakło wody w zbiorniku. Być może woda jest wyłączona lub występują inne problemy z urządzeniem"

#: src/containers/Sales/DeviceIncome.tsx:62
#: src/containers/Omnidesk/OmniChat.tsx:46
msgid "Закрыть"
msgstr "Zamknij"

#: src/containers/Migrations/Migrations.tsx:1094
msgid "Замена monotonic telemetry в PostgreSQL"
msgstr "Zastępowanie telemetry monotonicznej w PostgreSQL"

#: src/components/CartridgeValue/EditValueModal.tsx:57
#: src/components/CartridgeValue/EditValueModal.tsx:199
msgid "Замена картриджа {name}"
msgstr "Wymiana wkładu {name}"

#: src/containers/Migrations/Migrations.tsx:1196
msgid "Запустить миграцию"
msgstr "Uruchom migrację"

#: src/containers/Migrations/Migrations.tsx:1186
msgid "Запустить оценку"
msgstr "Uruchom szacowanie"

#: src/containers/Migrations/Migrations.tsx:2715
msgid "Затрачено на миграцию, чч:мм:сс"
msgstr "Czas poświęcony na migrację, gg:mm:ss"

#: src/containers/Migrations/Migrations.tsx:2699
msgid "Затрачено на оценку, чч:мм:сс"
msgstr "Czas poświęcony na estymację, gg:mm:ss"

#: src/containers/Migrations/Migrations.tsx:2541
msgid "Значение сохраняется после отпускания ползунка. Ноль приостанавливает новые запросы к DynamoDB."
msgstr "Wartość jest zapisywana po zwolnieniu suwaka. Zero wstrzymuje nowe zapytania do DynamoDB."

#: src/containers/SystemMaintenance/MaintenancePage.tsx:13
msgid "Идут технические работы"
msgstr "Trwają prace techniczne"

#: src/components/EditAuditComment/EditAuditCommentModal.tsx:70
msgid "Изменение комментария"
msgstr "Edycja komentarza"

#: src/containers/Migrations/Migrations.tsx:2888
msgid "Изменено аппаратов: {synchronizedDeviceCount}"
msgstr "Zmieniono urządzenia: {synchronizedDeviceCount}"

#: src/containers/Services/ChangeBalance.tsx:60
msgid "Изменить"
msgstr "Zmień"

#: src/components/LastServiceDate/LastServiceDate.tsx:143
msgid "Изменить дату обслуживания: {Address}"
msgstr "Zmień datę usługi: {Address}"

#: src/components/LastServiceDate/LastServiceDate.tsx:151
msgid "Изменить для всех"
msgstr "Zmień dla wszystkich"

#: src/containers/Migrations/Migrations.tsx:2785
msgid "Изменить статус миграции на «Не начата»"
msgstr "Zmień status migracji na „Nierozpoczęta”"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:85
msgid "Изменяющие запросы portal и обработка сообщений worker будут приостановлены."
msgstr "Żądania modyfikujące portalu i przetwarzanie wiadomości przez workery zostaną wstrzymane."

#: src/locales/constants.ts:28
msgid "импульс/кВт"
msgstr "impuls/kw"

#: src/locales/constants.ts:29
msgid "импульс/литр"
msgstr "impuls/litr"

#: src/locales/constants.ts:48
msgid "Имя"
msgstr "Nazwa"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:41
msgid "Имя сети (SSID)"
msgstr "Nazwa sieci (SSID)"

#: src/components/ConnectBot/ConnectMaxBot.tsx:42
#: src/components/ConnectBot/ConnectMaxBot.tsx:251
#: src/components/ConnectBot/ConnectMaxBot.tsx:257
#: src/components/ConnectBot/ConnectBot.tsx:41
#: src/components/ConnectBot/ConnectBot.tsx:259
#: src/components/ConnectBot/ConnectBot.tsx:265
msgid "Имя скрыто"
msgstr "Imię ukryte"

#: src/containers/Terminals/Terminal/Device.tsx:103
#: src/containers/Migrations/Migrations.tsx:576
#: src/containers/Migrations/Migrations.tsx:825
#: src/containers/Migrations/Migrations.tsx:3072
#: src/config/menu.tsx:66
msgid "Инкассации"
msgstr "Inkasacje"

#: src/containers/Main/Header.tsx:136
msgid "Интернет магазин"
msgstr "Sklep internetowy"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:65
msgid "Информация"
msgstr "Informacje"

#: src/containers/OraclePage/EditDataTab/OracleHistoryInput/HistoryDataForm/HistoryDataForm.tsx:85
msgid "исторические данные"
msgstr "dane historyczne"

#: src/containers/Services/BalanceHistory.tsx:102
msgid "История операций"
msgstr "Historia operacji"

#: src/containers/Services/PaymentType.tsx:39
#: src/containers/Services/PaymentType.tsx:40
msgid "Карты эмитированные банками РФ"
msgstr "Karty wydane przez banki Rosji"

#: src/containers/Services/PaymentType.tsx:38
msgid "Карты эмитированные иностранными банками"
msgstr "Karty wydane przez banki zagraniczne"

#: src/locales/constants.ts:31
msgid "кВт*час"
msgstr "kWh"

#: src/locales/constants.ts:30
msgid "кВт/час"
msgstr "kw/h"

#: src/containers/Login/LoginForm.tsx:50
msgid "Код восстановления выслан на почту"
msgstr "Kod odzyskiwania wysłany na e-mail"

#: src/containers/Users/UserMenu.tsx:78
msgid "Код для смены пароля отправлен"
msgstr "Kod do zmiany hasła wysłany"

#: src/containers/Migrations/Migrations.tsx:3048
msgid "Кол-во"
msgstr "Liczba"

#: src/containers/Dashboard/Devices/utils.ts:69
msgid "Количество активный аппаратов"
msgstr "Liczba aktywnych urządzeń"

#: src/containers/UserGroups/useUserGroupColumns.tsx:63
msgid "Количество активных аппаратов"
msgstr "Liczba aktywnych urządzeń"

#: src/containers/UserGroups/useUserGroupColumns.tsx:58
#: src/containers/Migrations/Migrations.tsx:2996
#: src/containers/Dashboard/Devices/Devices.tsx:54
msgid "Количество аппаратов"
msgstr "Ilość urządzeń"

#: src/containers/Terminals/Terminal/DeviceState/BotlerStatus.tsx:24
msgid "Количество бутылок в ячейках"
msgstr "Ilość butelek w komórkach"

#: src/containers/UserGroups/useUserGroupColumns.tsx:53
msgid "Количество пользователей"
msgstr "Liczba użytkowników"

#: src/containers/Services/Services.tsx:195
msgid "Количество установок ДСО"
msgstr "Liczba instalacji DSC"

#: src/containers/Staff/StaffForm.tsx:80
msgid "Комментарий"
msgstr "Komentarz̆"

#: src/containers/Services/ChangeBalance.tsx:56
msgid "Комментарий"
msgstr "Komentarz"

#: src/components/LastServiceDate/LastServiceDate.tsx:162
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:86
msgid "Комментарий по желанию"
msgstr "Komentarz (opcjonalnie)"

#: src/components/CommentForm/CommentForm.tsx:29
msgid "Комментарий сохранен"
msgstr "Komentarz zapisany"

#: src/components/EditAuditComment/EditAuditCommentModal.tsx:55
msgid "Комментарий успешно изменен"
msgstr "Komentarz został pomyślnie zmieniony"

#: src/locales/constants.ts:44
msgid "Компания"
msgstr "Spółka"

#: src/containers/Migrations/Migrations.tsx:922
#: src/containers/Migrations/Migrations.tsx:2381
msgid "Конвейер миграции"
msgstr "Potok migracji"

#: src/containers/Migrations/Migrations.tsx:386
msgid "Конец"
msgstr "Koniec"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:130
msgid "Концентрация состава"
msgstr "Stężenie składu"

#: src/features/deviceAlerts/i18n/translations.ts:14
msgid "Кончилась сдача"
msgstr "Koniec poddania się"

#: src/components/DeviceRemain.tsx:83
msgid "Корректировать остаток воды"
msgstr "Korygowanie pozostałości wody"

#: src/containers/Services/ChangeBalance.tsx:47
msgid "Корректировка баланса:"
msgstr "Korekta salda:"

#: src/containers/Services/BalanceHistory.tsx:57
msgid "Кто сделал"
msgstr "Kto zrobił"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:132
msgid "Купюры"
msgstr "Banknot"

#: src/locales/constants.ts:32
#: src/containers/DeviceList/columns/mobile.tsx:55
#: src/containers/DeviceList/columns/desktop.tsx:154
msgid "л"
msgstr "l"

#: src/locales/constants.ts:33
#: src/containers/DeviceList/columns/mobile.tsx:106
msgid "л/мин"
msgstr "l/chw"

#: src/containers/Sales/useSalesColumns.tsx:39
msgid "Лейбл"
msgstr "Etykieta"

#: src/containers/Migrations/Migrations.tsx:1762
msgid "Лимит чтения DynamoDB обновлён: {value} RCU/s"
msgstr "Zaktualizowano limit odczytu DynamoDB: {value} RCU/s"

#: src/components/Stats/constants.ts:18
msgid "Литры"
msgstr "Litry"

#: src/containers/Terminals/Terminal/Device.tsx:132
msgid "Логи"
msgstr "Logi"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:62
msgid "Логи билинга"
msgstr "Billing logs"

#: src/config/menu.tsx:111
msgid "Логи пользователя"
msgstr "Logi"

#: src/locales/constants.ts:56
#: src/containers/Staff/StaffUserSelect.tsx:48
#: src/containers/Migrations/Migrations.tsx:726
#: src/containers/Login/LoginForm.tsx:74
msgid "Логин"
msgstr "Login"

#: src/containers/Migrations/Migrations.tsx:332
msgid "м"
msgstr "m"

#: src/locales/constants.ts:39
msgid "м³"
msgstr "m³"

#: src/containers/Services/Recharge.tsx:68
msgid "Максимальная сумма платежа {maxPaymentSum}₽"
msgstr "Maksymalna kwota płatności {maxPaymentSum}₽"

#: src/features/deviceAlerts/i18n/translations.ts:15
msgid "Малое количество средств на балансе SIM карты"
msgstr "Niewielka ilość środków na saldzie karty SIM"

#: src/components/Stats/constants.ts:13
msgid "Месяц"
msgstr "Miesiąc"

#: src/containers/Migrations/Migrations.tsx:2339
#: src/config/menu.tsx:138
msgid "Миграции"
msgstr "Migracje"

#: src/containers/Migrations/Migrations.tsx:2583
msgid "Миграция данных"
msgstr "Migracja danych"

#: src/containers/Migrations/Migrations.tsx:2349
msgid "Миграция пользовательских данных"
msgstr "Migracja danych użytkowników"

#: src/containers/Migrations/Migrations.tsx:1885
#: src/containers/Migrations/Migrations.tsx:1962
msgid "Миграция пользователя завершена"
msgstr "Migracja użytkownika zakończona"

#: src/containers/Migrations/Migrations.tsx:1901
#: src/containers/Migrations/Migrations.tsx:1979
msgid "Миграция пользователя завершилась с ошибкой"
msgstr "Migracja użytkownika zakończyła się błędem"

#: src/containers/Migrations/Migrations.tsx:1911
msgid "Миграция пользователя запущена"
msgstr "Migracja użytkownika uruchomiona"

#: src/containers/Migrations/Migrations.tsx:2663
msgid "Мигрировало пользователей"
msgstr "Zmigrowani użytkownicy"

#: src/locales/constants.ts:35
msgid "мин"
msgstr "chw"

#: src/containers/Services/Recharge.tsx:67
msgid "Минимальна сумма платежа {minPaymentSum}₽"
msgstr "Minimalna kwota płatności {minPaymentSum}₽"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:138
msgid "Монеты"
msgstr "Bilon"

#: src/containers/Dashboard/AllMoney/utils.ts:37
msgid "Мониторинг"
msgstr "Monitoring"

#: src/containers/Migrations/Migrations.tsx:353
msgid "мс"
msgstr "ms"

#: src/containers/Services/Services.tsx:114
msgid "Нажмите на кнопку \"Пополнить баланс\" для пополнения баланса"
msgstr "Kliknij przycisk \"Doładuj saldo\", aby uzupełnić saldo"

#: src/components/CartridgeValue/EditValueModal.tsx:109
msgid "Нажмите ПЕРЕСЧИТАТЬ, если вы действительно поменяли счетчик ХВС на новый. Параметр ОСТАЛОСЬ ДО ЗАМЕНЫ будет пересчитан чтобы показывать корректные значения"
msgstr "Naciśnij PRZELICZ, jeśli faktycznie wymieniłeś licznik zimnej wody na nowy. Parametr POZOSTAŁO DO WYMIANY zostanie przeliczony, aby pokazywać poprawne wartości."

#: src/containers/UserGroups/useUserGroupColumns.tsx:30
msgid "Название группы"
msgstr "Nazwa zespołu"

#: src/locales/constants.ts:57
msgid "Налоговый идентификатор"
msgstr "Identyfikator podatkowy"

#: src/containers/Migrations/Migrations.tsx:2555
msgid "Настройка ограничения записи будет добавлена позже."
msgstr "Konfiguracja limitu zapisu zostanie dodana później."

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:13
msgid "Настройки бутылочника"
msgstr "Usustawienia rozlewni"

#: src/containers/Terminals/EditDevice/NotificationSettingsFields.tsx:22
msgid "Настройки оповещений"
msgstr "Ustawienia powiadomień"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:38
msgid "Настройки подключения по Wi-Fi"
msgstr "Ustawienia połączenia Wi-Fi"

#: src/containers/Migrations/Migrations.tsx:380
msgid "Начало"
msgstr "Rozpoczęcie"

#: src/containers/Migrations/Migrations.tsx:1039
msgid "Не выполняется"
msgstr "Nie jest wykonywane"

#: src/containers/Report/ReportContainer.tsx:26
msgid "Не найден корневой элемент"
msgstr "Nie znaleziono elementu głównego"

#: src/containers/Migrations/Migrations.tsx:241
msgid "Не начата"
msgstr "Nie rozpoczęto"

#: src/components/LastServiceDate/LastServiceDate.tsx:184
msgid "Не обслуживался"
msgstr "Nie serwisowany"

#: src/containers/Services/Services.tsx:72
msgid "Не подключена"
msgstr "Nie połączony"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:87
msgid "НЕ РЕКОМЕНДУЕТСЯ прошивать аппарат прошивкой tcp (это прошивки с индексом 6.00.ХХХ) Для таких аппаратов рекомендуем прошивку 4.34.37 или 4.37.67"
msgstr "Nie zaleca się flashowania urządzenia za pomocą oprogramowania układowego tcp (jest to oprogramowanie układowe o indeksie 6.00.XXX) dla takich urządzeń zalecamy firmware 4.34.37 lub 4.37.67"

#: src/containers/Encash/EncashComment.tsx:31
msgid "Не удалось добавить комментарий"
msgstr "Nie udało się dodać komentarza"

#: src/containers/Migrations/Migrations.tsx:1744
msgid "Не удалось запустить миграцию данных"
msgstr "Nie udało się uruchomić migracji danych"

#: src/containers/Migrations/Migrations.tsx:1925
msgid "Не удалось запустить миграцию пользователя"
msgstr "Nie udało się uruchomić migracji użytkownika"

#: src/containers/Migrations/Migrations.tsx:1718
msgid "Не удалось запустить оценку пользователей"
msgstr "Nie udało się uruchomić szacowania użytkowników"

#: src/containers/Services/ChangeBalance.tsx:33
msgid "Не удалось изменить баланс"
msgstr "Nie udało się zmienić salda"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:120
msgid "Не удалось изменить режим технических работ"
msgstr "Nie udało się zmienić trybu prac technicznych"

#: src/containers/Migrations/Migrations.tsx:2251
msgid "Не удалось изменить статус миграции пользователей"
msgstr "Nie udało się zmienić statusu migracji użytkowników"

#: src/containers/Staff/StaffForm.tsx:39
msgid "Не удалось обновить данные о сотруднике"
msgstr "Nie można zaktualizować danych pracownika"

#: src/components/LastServiceDate/LastServiceDate.tsx:110
msgid "Не удалось обновить дату последнего обслуживания"
msgstr "Nie można zaktualizować daty ostatniej konserwacji"

#: src/containers/Migrations/Migrations.tsx:1767
msgid "Не удалось обновить лимит чтения DynamoDB"
msgstr "Nie udało się zaktualizować limitu odczytu DynamoDB"

#: src/containers/Migrations/Migrations.tsx:1743
msgid "Не удалось остановить миграцию данных"
msgstr "Nie udało się zatrzymać migracji danych"

#: src/containers/Migrations/Migrations.tsx:1717
msgid "Не удалось остановить оценку пользователей"
msgstr "Nie udało się zatrzymać szacowania użytkowników"

#: src/containers/Migrations/Migrations.tsx:2919
msgid "Не удалось получить аппараты для миграции"
msgstr "Nie udało się pobrać urządzeń do migracji"

#: src/containers/Migrations/Migrations.tsx:2982
msgid "Не удалось получить данные для визуализации"
msgstr "Nie udało się pobrać danych do wizualizacji"

#: src/containers/Migrations/Migrations.tsx:2511
msgid "Не удалось получить лимит чтения DynamoDB"
msgstr "Nie udało się pobrać limitu odczytu DynamoDB"

#: src/containers/Migrations/Migrations.tsx:2825
msgid "Не удалось получить пользователей для миграции"
msgstr "Nie udało się pobrać użytkowników do migracji"

#: src/containers/Migrations/Migrations.tsx:2650
msgid "Не удалось получить сводные показатели миграции"
msgstr "Nie udało się pobrać podsumowania migracji"

#: src/components/ConnectBot/ConnectMaxBot.tsx:76
#: src/components/ConnectBot/ConnectBot.tsx:75
msgid "Не удалось получить ссылку на подключение"
msgstr "Nie udało się uzyskać linku do połączenia"

#: src/containers/Migrations/Migrations.tsx:2359
msgid "Не удалось получить статус migrator"
msgstr "Nie udało się pobrać statusu migratora"

#: src/containers/Migrations/Migrations.tsx:1995
msgid "Не удалось получить статус миграции пользователя"
msgstr "Nie udało się pobrać statusu migracji użytkownika"

#: src/containers/Migrations/Migrations.tsx:2058
msgid "Не удалось получить статус расчёта"
msgstr "Nie udało się pobrać statusu szacowania"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:130
msgid "Не удалось получить статусы worker pod'ов"
msgstr "Nie udało się pobrać statusów podów workerów"

#: src/containers/Sales/DeviceIncome.tsx:33
msgid "Не удалось пополнить баланс"
msgstr "Nie udało się uzupełnić salda"

#: src/containers/Migrations/Migrations.tsx:1837
#: src/containers/Migrations/Migrations.tsx:1847
#: src/containers/Migrations/Migrations.tsx:2044
msgid "Не удалось рассчитать метрики пользователя"
msgstr "Nie udało się obliczyć metryk użytkownika"

#: src/containers/Migrations/Migrations.tsx:2900
msgid "Не удалось синхронизировать аппараты"
msgstr "Nie udało się zsynchronizować urządzeń"

#: src/containers/Migrations/Migrations.tsx:2767
msgid "Не удалось синхронизировать пользователей"
msgstr "Nie udało się zsynchronizować użytkowników"

#: src/components/ConnectBot/ConnectMaxBot.tsx:114
#: src/components/ConnectBot/ConnectBot.tsx:120
msgid "Не удалось скопировать ссылку в буфер обмена, сделайте это вручную"
msgstr "Nie udało się skopiować linku do schowka, zrób to ręcznie"

#: src/components/DeviceRemain.tsx:31
msgid "Не удалось скорректировать остаток"
msgstr "Nie udało się skorygować pozostałości wody"

#: src/containers/Terminals/NewDevice/NewDevice.tsx:59
msgid "Не удалось создать аппарат"
msgstr "Nie udało się utworzyć urządzenia"

#: src/components/CommentForm/CommentForm.tsx:33
msgid "Не удалось сохранить комментарий"
msgstr "Nie udało się zapisać komentarza"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:164
msgid "Не удалось сравнить состояния аппарата"
msgstr "Nie udało się porównać stanów urządzenia"

#: src/containers/Staff/StaffForm.tsx:60
msgid "Не удалось удалить данные о сотруднике"
msgstr "Nie można usunąć danych pracownika"

#: src/containers/Users/UserMenu.tsx:105
msgid "Не удалось удалить пользователя"
msgstr "Nie udało się usunąć użytkownika"

#: src/components/LastServiceDate/LastServiceDate.tsx:79
msgid "Не указана дата обслуживания"
msgstr "Nie podano daty usługi"

#: src/containers/Users/NewUser.tsx:46
msgid "Неверный формат"
msgstr "Nieprawidłowy format"

#: src/components/Stats/constants.ts:12
msgid "Неделя"
msgstr "Tydzień"

#: src/containers/Services/Services.tsx:62
msgid "Недостаточно денежных средств для подключения данной услуги"
msgstr "Niewystarczające środki na koncie do aktywacji tej usługi"

#: src/containers/Terminals/BlockedByService/BlockedByService.tsx:5
msgid "Недостаточно средств для отображения списка устройств"
msgstr "Niewystarczające środki do wyświetlenia listy urządzeń"

#: src/ui-kit/Form/Switch/Switch.tsx:139
#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:113
#: src/components/Switch.tsx:81
msgid "Нет"
msgstr "Nie"

#: src/containers/Migrations/Migrations.tsx:1138
msgid "Нет активной операции"
msgstr "Brak aktywnej operacji"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:181
msgid "Нет аппаратов с таким адресом"
msgstr "Nie ma urządzeń O Takim Adresie"

#: src/ui-kit/Table/Table.tsx:229
msgid "Нет данных"
msgstr "Brak danych"

#: src/containers/Migrations/Migrations.tsx:3027
msgid "Нет данных для визуализации"
msgstr "Brak danych do wizualizacji"

#: src/features/deviceAlerts/i18n/translations.ts:13
msgid "Нет платежей по каналу безналичная оплата (оплата банковской картой) более 2x часов"
msgstr "Brak płatności bezgotówkowych (kartą bankową) przez ponad 2 godziny"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:97
msgid "Нет связи с платой водоподготовки"
msgstr "Brak połączenia z płytą uzdatniania wody"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:82
msgid "Нет связи с платой управления"
msgstr "Brak połączenia z płytą sterującą"

#: src/containers/Services/ChangeBalance.tsx:51
msgid "Новый баланс"
msgstr "Nowe saldo"

#: src/containers/Login/LoginForm.tsx:100
msgid "Новый пароль"
msgstr "Nowe hasło"

#: src/containers/Dashboard/AllMoney/utils.ts:65
msgid "Новых устройств за период"
msgstr "Nowych urządzeń w okresie"

#: src/containers/Dashboard/AllMoney/utils.ts:73
msgid "Новых устройств: оплачен App/QR"
msgstr "Nowych urządzeń: opłacone App/QR"

#: src/containers/Dashboard/AllMoney/utils.ts:69
msgid "Новых устройств: оплачен мониторинг"
msgstr "Nowych urządzeń: opłacony monitoring"

#: src/containers/Dashboard/AllMoney/utils.ts:77
msgid "Новых устройств: оплачен мониторинг + App/QR"
msgstr "Nowych urządzeń: opłacony monitoring + App/QR"

#: src/locales/constants.ts:15
msgid "Номер SIM"
msgstr "Numer karty SIM"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:112
msgid "Номер Техподдержки"
msgstr "Numer pomocy technicznej"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:72
msgid "Номер Техподдержки в 1 строке"
msgstr "Numer wsparcia technicznego w 1 linii"

#: src/containers/Migrations/Migrations.tsx:242
msgid "Нужен частичный пересчёт"
msgstr "Wymagane częściowe przeliczenie"

#: src/containers/Migrations/Migrations.tsx:2481
msgid "Обновить"
msgstr "Odśwież"

#: src/containers/Migrations/Migrations.tsx:1100
msgid "Обновление progress.txt"
msgstr "Aktualizowanie progress.txt"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:120
msgid "Оборудование"
msgstr "Sprzęt"

#: src/containers/Dashboard/BillingStats/columns.tsx:68
msgid "Обработано с ошибкой"
msgstr "Processed with errors"

#: src/containers/Terminals/EditDevice/PromoField.tsx:11
msgid "Обратите внимание, для корректной работы режима Промоакция параметр Автостоп наличные/банк.карта установлен равным 5 литров"
msgstr "Zwróć uwagę, że dla prawidłowej pracy trybu Promocja parametr AUTOSTOP jest ustawiony na 5 litrów."

#: src/components/BYNotification.tsx:26
msgid "Обращаем ваше внимание, что с 14.07.2026 для вендоров из Республики Беларусь техническая поддержка осуществляется ТОЛЬКО силами специалистов компании Живая Вода Россия. Телеграмм чат технической поддержки<0>@alivewaternewbot</0>"
msgstr "Zwracamy uwagę, że od 14.07.2026 dla dostawców z Republiki Białorusi wsparcie techniczne jest realizowane tylko przez specjalistów firmy Living Voda Rosja. Telegram czat pomocy technicznej<0>@alivewaternewbot</0>"

#: src/containers/DeviceList/columns/list.tsx:84
#: src/containers/DeviceList/columns/desktop.tsx:220
msgid "Обслуживание"
msgstr "Obsługa"

#: src/containers/Dashboard/Users/Users.tsx:47
msgid "Общая статистика"
msgstr "Ogólne statystyki"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:62
msgid "Общее"
msgstr "Ogólny"

#: src/containers/Migrations/Migrations.tsx:3099
msgid "Общий объём"
msgstr "Łączna objętość"

#: src/containers/Services/Recharge.tsx:66
msgid "Обязательное поле"
msgstr "Pole wymagane"

#: src/containers/Migrations/Migrations.tsx:2552
msgid "Ограничение записи PostgreSQL"
msgstr "Limit zapisu PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:2501
msgid "Ограничение чтения DynamoDB"
msgstr "Limit odczytu DynamoDB"

#: src/containers/Migrations/Migrations.tsx:226
#: src/containers/Migrations/Migrations.tsx:243
msgid "Ожидает"
msgstr "Oczekuje"

#: src/containers/Migrations/Migrations.tsx:2371
msgid "Ожидает запуска"
msgstr "Oczekuje na uruchomienie"

#: src/containers/Dashboard/Geography/Geography.tsx:26
msgid "Округа: {districtCount}"
msgstr "Okręgi: {districtCount}"

#: src/config/menu.tsx:117
msgid "ОМНИДЕСК-сообщения"
msgstr "OMNIDESK-wiadomości"

#: src/containers/UserInfo/UserInfo.tsx:68
#: src/containers/Omnidesk/OmnuUser.tsx:20
msgid "Онлайн"
msgstr "On line"

#: src/containers/UserGroups/useUserGroupColumns.tsx:49
msgid "Описание"
msgstr "Opis"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:145
msgid "Оплата через приложение"
msgstr "Płatność za pośrednictwem aplikacji"

#: src/containers/Dashboard/Devices/utils.ts:64
msgid "Оплаченных"
msgstr "Opłacony"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:41
msgid "Оплачу позже"
msgstr "Zapłacę później"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:24
msgid "Оповещения"
msgstr "Poinformowanie"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:21
msgid "Основные настройки"
msgstr "Podstawowe ustawienia"

#: src/containers/Migrations/Migrations.tsx:2721
msgid "Осталось на миграцию, чч:мм:сс (прогноз)"
msgstr "Pozostały czas migracji, gg:mm:ss (prognoza)"

#: src/containers/Migrations/Migrations.tsx:2705
msgid "Осталось на оценку, чч:мм:сс (прогноз)"
msgstr "Pozostały czas estymacji, gg:mm:ss (prognoza)"

#: src/containers/Migrations/Migrations.tsx:1044
msgid "Останавливается"
msgstr "Zatrzymywanie"

#: src/containers/Migrations/Migrations.tsx:1055
msgid "Останавливается после пользователя"
msgstr "Zatrzymywanie po użytkowniku"

#: src/containers/Migrations/Migrations.tsx:1184
#: src/containers/Migrations/Migrations.tsx:1194
msgid "Останавливается…"
msgstr "Zatrzymywanie…"

#: src/containers/Migrations/Migrations.tsx:1195
msgid "Остановить миграцию"
msgstr "Zatrzymaj migrację"

#: src/containers/Migrations/Migrations.tsx:1185
msgid "Остановить оценку"
msgstr "Zatrzymaj szacowanie"

#: src/containers/Migrations/Migrations.tsx:2600
msgid "Остановка оценки завершает текущего пользователя и не начинает следующего. Остановка миграции работает так же: текущий пользователь завершается полностью."
msgstr "Zatrzymanie estymacji kończy bieżącego użytkownika i nie rozpoczyna następnego. Zatrzymanie migracji działa tak samo: bieżący użytkownik jest przetwarzany do końca."

#: src/components/DeviceRemain.tsx:45
msgid "Остаток"
msgstr "Pozostałości wody"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:172
msgid "Остаток воды"
msgstr "Pozostałość wody"

#: src/components/DeviceRemain.tsx:27
msgid "Остаток скорректирован"
msgstr "Skorygowana pozostałość wody"

#: src/containers/DeviceList/columns/desktop.tsx:70
msgid "Остаток тары"
msgstr "Pozostały butelki"

#: src/containers/Migrations/Migrations.tsx:964
msgid "Открывает аппарат пользователя в Alivewater Cloud"
msgstr "Otwiera urządzenie użytkownika w Alivewater Cloud"

#: src/containers/Migrations/Migrations.tsx:978
msgid "Открывает вкладку аппаратов с фильтром по этому пользователю"
msgstr "Otwiera kartę urządzeń z filtrem dla tego użytkownika"

#: src/containers/Migrations/Migrations.tsx:986
msgid "Открывает список аппаратов пользователя в Alivewater Cloud"
msgstr "Otwiera listę urządzeń użytkownika w Alivewater Cloud"

#: src/containers/Migrations/Migrations.tsx:962
msgid "Открыть аппарат на production-площадке"
msgstr "Otwórz urządzenie w środowisku produkcyjnym"

#: src/containers/Migrations/Migrations.tsx:984
msgid "Открыть на production-площадке"
msgstr "Otwórz w środowisku produkcyjnym"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:88
msgid "Отмена"
msgstr "Anuluj"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:112
#: src/containers/Staff/StaffForm.tsx:94
#: src/containers/Services/Recharge.tsx:113
msgid "Отменить"
msgstr "Anuluj"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:181
msgid "Отсутствует в PostgreSQL"
msgstr "Brak w PostgreSQL"

#: src/locales/constants.ts:51
msgid "Отчество"
msgstr "Imię ojca"

#. placeholder {0}: date ? t`за ${DateTime.fromMillis(Number(date)) .setLocale('ru-ru') .toFormat('dd-MM-yyyy')}` : null
#: src/containers/Report/Report.tsx:52
msgid "Отчет {user} {0}"
msgstr "Raport {user} {0}"

#: src/containers/Dashboard/Devices/Devices.tsx:32
#: src/containers/Dashboard/AllMoney/AllMoney.tsx:71
msgid "Отчетный период:"
msgstr "Okres sprawozdawczy:"

#: src/containers/Users/UsersList.tsx:32
#: src/containers/UserInfo/UserInfo.tsx:68
#: src/containers/Omnidesk/OmnuUser.tsx:20
msgid "Оффлайн"
msgstr "Offline"

#: src/containers/Migrations/Migrations.tsx:2568
msgid "Оценка пользователей"
msgstr "Szacowanie użytkowników"

#: src/containers/Migrations/Migrations.tsx:1810
msgid "Оценка пользователя завершена"
msgstr "Szacowanie użytkownika zakończone"

#: src/containers/Migrations/Migrations.tsx:2458
msgid "Очередь Query"
msgstr "Kolejka zapytań"

#: src/containers/Migrations/Migrations.tsx:229
#: src/containers/Migrations/Migrations.tsx:246
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:24
msgid "Ошибка"
msgstr "Error"

#: src/contexts/UserContext/UserContext.tsx:72
msgid "Ошибка авторизации"
msgstr "Błąd autoryzacji"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:130
msgid "Ошибка активации аппарата"
msgstr "Błąd aktywacji urządzenia"

#: src/containers/Login/LoginForm.tsx:54
msgid "Ошибка восстановления пароля"
msgstr "Błąd odzyskiwania hasła"

#: src/contexts/UserContext/UserContext.tsx:277
msgid "Ошибка входа"
msgstr "Błąd logowania"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:31
msgid "Ошибка выполнения операции"
msgstr "Błąd wykonania operacji"

#: src/features/deviceAlerts/i18n/translations.ts:18
msgid "Ошибка купюроприемника"
msgstr "Błąd akceptanta rachunków"

#: src/containers/Migrations/Migrations.tsx:665
#: src/containers/Migrations/Migrations.tsx:916
msgid "Ошибка миграции"
msgstr "Błąd migracji"

#: src/features/deviceAlerts/i18n/translations.ts:19
msgid "Ошибка монетоприемника"
msgstr "Błąd akceptora monet"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:90
msgid "Ошибка операции"
msgstr "Błąd operacji"

#: src/containers/Migrations/Migrations.tsx:647
#: src/containers/Migrations/Migrations.tsx:897
msgid "Ошибка оценки"
msgstr "Błąd szacowania"

#: src/contexts/UserContext/UserContext.tsx:306
msgid "Ошибка сброса пароля"
msgstr "Błąd resetowania hasła"

#: src/features/deviceAlerts/i18n/translations.ts:17
msgid "Ошибка фискального сервера"
msgstr "Błąd serwera fiskalnego"

#: src/containers/Migrations/Migrations.tsx:2424
msgid "Память pod: свободно / всего"
msgstr "Pamięć poda: wolna / łącznie"

#: src/containers/Migrations/Migrations.tsx:2343
msgid "Панель управления миграцией"
msgstr "Panel sterowania migracją"

#: src/locales/constants.ts:52
#: src/containers/Terminals/EditDevice/WifiFields.tsx:54
#: src/containers/Login/LoginForm.tsx:86
msgid "Пароль"
msgstr "Hasło"

#: src/containers/Users/UserMenu.tsx:143
msgid "Пароль пользователя<0>{Username}</0>будет сброшен. На адрес {Email} будет отправлен код восстановления."
msgstr "Hasło użytkownika<0> {Username}</0> zostanie zresetowane. Kod odzyskiwania zostanie wysłany na adres {Email}."

#: src/locales/constants.ts:60
msgid "Перевод отсутствует"
msgstr ".................."

#: src/containers/Terminals/Terminal/ResetDevice.tsx:40
msgid "Перезагрузить плату управления"
msgstr "Uruchom ponownie tablicę kontrolną"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:40
msgid "Перейти к оплате"
msgstr "Przejdź do płatności"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:107
msgid "Перейти на редактирование вторичного устройства"
msgstr "Przejdź do edycji urządzenia wtórnego"

#: src/containers/Migrations/Migrations.tsx:953
msgid "Перенести данные пользователя"
msgstr "Migruj dane użytkownika"

#: src/components/CartridgeValue/EditValueModal.tsx:106
msgid "Пересчитать"
msgstr "Przelicz"

#: src/components/CartridgeValue/EditValueModal.tsx:105
msgid "Пересчитать ресурс фильтров?"
msgstr "Przeliczyć zasób filtrów?"

#: src/containers/Sales/Sales.tsx:133
#: src/containers/Encash/Encash.tsx:88
#: src/components/Stats/Stats.tsx:144
msgid "Период"
msgstr "Okres"

#: src/containers/Services/BalanceHistory.tsx:110
msgid "Период:"
msgstr "Okres:"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:154
msgid "Периодичность запуска промывки ХВС {pflUnit}"
msgstr "Częstotliwość uruchamiania płukania zimnej wody {pflUnit}"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:123
msgid "Периодичность промывки"
msgstr "Częstotliwość płukania"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:82
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:22
msgid "Плата управления"
msgstr "Płyta sterowania"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:26
msgid "Плата управления будет перезагружена"
msgstr "Płyta sterowania zostanie ponownie uruchomiona"

#: src/containers/Dashboard/AllMoney/utils.ts:9
msgid "Платежи от ckassa"
msgstr "Płatności od ckassa"

#: src/containers/Dashboard/AllMoney/utils.ts:14
msgid "Платежными поручениями"
msgstr "Płatności przelewem"

#: src/containers/DeviceList/constants.ts:15
msgid "по адресу"
msgstr "według adresu"

#: src/containers/DeviceList/AuditTab/AuditTab.tsx:215
msgid "по адресу аппарата"
msgstr "według adresu urządzenia"

#: src/containers/DeviceList/constants.ts:14
msgid "по дате первого запуска"
msgstr "według daty pierwszego uruchomienia"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:39
msgid "По закату и рассвету (только Россия)"
msgstr "Według zachodu i wschodu słońca (tylko Rosja)"

#: src/containers/Migrations/Migrations.tsx:2968
msgid "По оси X — количество аппаратов у пользователя, по оси Y — количество пользователей."
msgstr "Oś X pokazuje liczbę urządzeń użytkownika, a oś Y liczbę użytkowników."

#: src/containers/DeviceList/constants.ts:19
msgid "по предупреждениям"
msgstr "według ostrzeżeń"

#: src/containers/DeviceList/constants.ts:16
msgid "по примечанию"
msgstr "według uwagi"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:32
msgid "По расписанию"
msgstr "Według harmonogramu"

#: src/containers/DeviceList/constants.ts:17
msgid "по сумме всего"
msgstr "według łącznej kwoty"

#: src/containers/DeviceList/constants.ts:18
msgid "по сумме за день"
msgstr "według kwoty za dzień"

#: src/containers/Migrations/Migrations.tsx:1084
msgid "Подготовка временного каталога"
msgstr "Przygotowywanie katalogu tymczasowego"

#: src/containers/Migrations/Migrations.tsx:1082
msgid "Подготовка списка аппаратов"
msgstr "Przygotowywanie listy urządzeń"

#: src/containers/Services/Services.tsx:68
msgid "Подключена"
msgstr "Połączony"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:149
msgid "Подсветка"
msgstr "Podświetlenie"

#: src/containers/DeviceList/DeviceList.tsx:309
msgid "Подсветка оповещений"
msgstr "Hilight alerts"

#: src/containers/Dashboard/Users/Users.tsx:79
msgid "Подтвержденных"
msgstr "Potwierdzonych"

#: src/containers/Dashboard/Users/Users.tsx:53
msgid "Подтвержденных:"
msgstr "Potwierdzonych:"

#: src/containers/SystemMaintenance/MaintenancePage.tsx:16
msgid "Пожалуйста, попробуйте выполнить операцию позже."
msgstr "Spróbuj ponownie wykonać operację później."

#: src/containers/Migrations/Migrations.tsx:2908
msgid "Поиск по Device ID или User ID"
msgstr "Szukaj według Device ID lub User ID"

#: src/containers/Migrations/Migrations.tsx:2805
msgid "Поиск по логину или User ID"
msgstr "Szukaj według loginu lub User ID"

#: src/containers/DeviceList/columns/desktop.tsx:119
msgid "Показания"
msgstr "Wskazania"

#: src/containers/Migrations/Migrations.tsx:976
msgid "Показать аппараты пользователя"
msgstr "Pokaż urządzenia użytkownika"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:151
msgid "Показать данные без форматирования"
msgstr "Pokaż dane bez formatowania"

#: src/containers/Migrations/Migrations.tsx:1061
msgid "Показать пользователя в таблице"
msgstr "Pokaż użytkownika w tabeli"

#: src/containers/Migrations/Migrations.tsx:970
msgid "Показывает различия между состояниями аппарата в DynamoDB и PostgreSQL"
msgstr "Pokazuje różnice między stanami urządzenia w DynamoDB i PostgreSQL"

#: src/components/ui/Pagination.tsx:56
msgid "Показывать{limitsSelect}записей"
msgstr "Pokaż{limitsSelect}rekordów"

#: src/locales/constants.ts:17
msgid "Поле примечание выводится в 5 строке экрана \"Аппараты\" в столбце Адрес. В этом поле вы можете указать дополнительную информацию к адресу установки. По этому полю так же возможно отсортировать аппараты."
msgstr "Pole notatki wyświetlane jest w wierszu 5 ekranu „Urządzenia” w kolumnie Adres. W tym polu możesz określić dodatkowe informacje o adresie instalacji. Można również sortować urządzenia według tego pola."

#: src/containers/Migrations/Migrations.tsx:949
msgid "Получает количество данных пользователя из DynamoDB"
msgstr "Pobiera liczbę danych użytkownika z DynamoDB"

#: src/containers/Migrations/Migrations.tsx:3017
msgid "Пользователей"
msgstr "Użytkownicy"

#: src/containers/Migrations/Migrations.tsx:2667
msgid "Пользователей с рассчитанными метриками"
msgstr "Użytkownicy z obliczonymi metrykami"

#: src/containers/Users/Users.tsx:25
#: src/containers/Migrations/Migrations.tsx:2743
#: src/containers/Dashboard/Dashboard.tsx:34
#: src/config/menu.tsx:42
msgid "Пользователи"
msgstr "Użytkownicy"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:19
msgid "Пользователь"
msgstr "użytkownik"

#: src/containers/Users/UserMenu.tsx:168
msgid "Пользователь <0>{Username}</0> будет заблокирован. Он не сможет авторизоваться в личном кабинете."
msgstr "użytkownik <0> {Username}</0> zostanie zablokowany. Nie będzie mógł zalogować się na swoim koncie osobistym."

#: src/containers/Users/UserMenu.tsx:119
msgid "Пользователь <0>{Username}</0> будет удален безвозвратно."
msgstr "Użytkownik <0> {Username}</0> zostanie trwale usunięty."

#: src/components/ConnectBot/ConnectMaxBot.tsx:159
msgid "Пользователь Max успешно отвязан"
msgstr "Użytkownik Max został pomyślnie odłączony"

#: src/containers/Users/UserMenu.tsx:91
msgid "Пользователь заблокирован"
msgstr "Użytkownik zablokowany"

#: src/containers/Users/UserMenu.tsx:92
msgid "Пользователь разблокирован"
msgstr "Użytkownik odblokowany"

#: src/containers/Users/NewUser.tsx:73
msgid "Пользователь создан. Данные отправлены на {Email}"
msgstr "Użytkownik został utworzony. Dane wysłane na {Email}"

#: src/containers/Users/UserMenu.tsx:103
msgid "Пользователь удален"
msgstr "Użytkownik usunięty"

#: src/containers/Users/NewUser.tsx:79
msgid "Пользователь уже существует"
msgstr "Użytkownik już istnieje"

#: src/containers/UserInfo/UserInfo.tsx:71
msgid "Пользователь:"
msgstr "Użytkownik:"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:25
#: src/components/ServiceNotificationModal.tsx:33
msgid "Понятно"
msgstr "Rozumiem"

#: src/containers/Services/Recharge.tsx:112
#: src/containers/Sales/DeviceIncome.tsx:59
msgid "Пополнить"
msgstr "Doładuj"

#: src/containers/Services/Recharge.tsx:106
#: src/containers/Services/Recharge.tsx:109
#: src/containers/Sales/DeviceIncome.tsx:90
msgid "Пополнить баланс"
msgstr "Doładuj saldo"

#: src/containers/Sales/DeviceIncome.tsx:86
msgid "Пополнить баланс клиенту на аппарате"
msgstr "Doładuj saldo klienta na urządzeniu"

#: src/containers/UserInfo/UserInfo.tsx:78
msgid "Последний визит:"
msgstr "Ostatnia wizyta:"

#: src/locales/constants.ts:50
msgid "Последний вход"
msgstr "Ostatnie logowanie"

#: src/containers/DeviceList/columns/mobile.tsx:309
#: src/containers/DeviceList/columns/desktop.tsx:168
msgid "Последний выход на связь"
msgstr "Ostatni kontakt"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:94
msgid "Последняя инкассация"
msgstr "Ostatnia zbiórka"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:110
#: src/containers/DeviceList/columns/mobile.tsx:324
#: src/containers/DeviceList/columns/desktop.tsx:183
msgid "Последняя продажа"
msgstr "Ostatnia sprzedaż"

#: src/containers/Sales/useSalesColumns.tsx:123
msgid "Потенциально фишинговая продажа"
msgstr "Potencjalna sprzedaż phishingowa"

#: src/features/deviceAlerts/components/DeviceAlerts.tsx:31
msgid "Предупреждений не обнаружено"
msgstr "Nie znaleziono ostrzeżeń"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:98
#: src/containers/DeviceList/columns/base.tsx:20
msgid "Предупреждения"
msgstr "Ostrzeżenie"

#: src/containers/Migrations/Migrations.tsx:671
msgid "Предыдущий User ID"
msgstr "Poprzedni User ID"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:91
#: src/containers/DeviceList/constants.ts:25
msgid "Приборы"
msgstr "Sztućce"

#: src/locales/constants.ts:16
#: src/containers/DeviceList/columns/list.tsx:115
msgid "Примечание"
msgstr "Notatka"

#: src/containers/Dashboard/BillingStats/columns.tsx:47
msgid "Прогноз завершения"
msgstr "Estimate time"

#: src/features/salesDynamics/ui/SalesDynamicsTotal.tsx:48
#: src/containers/DeviceList/columns/salesDynamicsColumns.tsx:23
msgid "Прогноз на {month}"
msgstr "Forecast {month}"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:176
msgid "Прогноз остатка на конец текущих суток"
msgstr "Prognoza salda na koniec bieżącego dnia"

#: src/containers/Dashboard/BillingStats/columns.tsx:42
msgid "Прогресс"
msgstr "Progress"

#: src/containers/Terminals/Terminal/Device.tsx:98
#: src/containers/Migrations/Migrations.tsx:571
#: src/containers/Migrations/Migrations.tsx:819
#: src/containers/Migrations/Migrations.tsx:3071
#: src/config/menu.tsx:60
msgid "Продажи"
msgstr "Sprzedaż"

#: src/containers/Migrations/Migrations.tsx:3038
msgid "Продажи, инкассации и события учитываются полностью. В альтернативных сценариях уменьшается только объединённая телеметрия."
msgstr "Sprzedaż, inkasa i zdarzenia są uwzględniane w całości. W alternatywnych scenariuszach zmniejszana jest tylko połączona telemetria."

#: src/containers/Migrations/Migrations.tsx:392
#: src/containers/Dashboard/BillingStats/columns.tsx:52
msgid "Продолжительность"
msgstr "Time spent"

#: src/containers/Users/UserMenu.tsx:125
#: src/containers/Users/UserMenu.tsx:151
#: src/containers/Users/UserMenu.tsx:174
msgid "Продолжить?"
msgstr "Kontynuować?"

#: src/config/menu.tsx:105
msgid "Проект Оракул"
msgstr "Oracle"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:18
msgid "Промывка ежедневно"
msgstr "Płukanie codziennie"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:14
msgid "Промывка отключена"
msgstr "Płukanie wyłączone"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:26
msgid "Промывка через два дня"
msgstr "Płukanie po dwóch dniach"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:22
msgid "Промывка через день"
msgstr "Płukanie co drugi dzień"

#: src/containers/Migrations/Migrations.tsx:2242
msgid "Пропущено выполняющихся миграций: {skippedCount}"
msgstr "Pominięto trwające migracje: {skippedCount}"

#: src/containers/UserInfo/UserInfo.tsx:94
#: src/containers/Profile/EditProfile.tsx:62
msgid "Профиль"
msgstr "Profil"

#: src/containers/Profile/EditProfile.tsx:53
msgid "Профиль обновлен"
msgstr "Profil zaktualizowany"

#: src/containers/Sales/SalesTotal.tsx:137
msgid "Процент конвертации (за текущие сутки): {conversion}"
msgstr "Procent konwersji (za bieżący dzień): {conversion}"

#: src/config/menu.tsx:87
msgid "Прошивка оборудования"
msgstr "Oprogramowanie sprzętowe"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:71
msgid "Прошивка платы управления"
msgstr "Oprogramowanie układowe płyty sterującej"

#: src/containers/Users/UserMenu.tsx:215
msgid "Разблокировать"
msgstr "Odblokować"

#: src/containers/Migrations/Migrations.tsx:2462
msgid "Размер страницы Query"
msgstr "Rozmiar strony zapytania"

#: src/containers/OraclePage/ComputeTab/utils.ts:110
msgid "Разовые расходы в выбранный период отсутствуют"
msgstr "Brak jednorazowych wydatków w wybranym okresie"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:164
msgid "Разрешить водоподготовку"
msgstr "Pozwól na uzdatnianie wody"

#: src/locales/constants.ts:20
msgid "Разрешить продажу минеральной воды"
msgstr "Zezwól na sprzedaż wody mineralnej"

#: src/containers/Terminals/Terminal/Device.tsx:109
msgid "Расписание"
msgstr "Rozkład"

#: src/containers/Migrations/Migrations.tsx:2963
msgid "Распределение пользователей по количеству аппаратов"
msgstr "Rozkład użytkowników według liczby urządzeń"

#: src/containers/Migrations/Migrations.tsx:947
msgid "Рассчитать метрики пользователя"
msgstr "Oblicz metryki użytkownika"

#: src/containers/Services/Services.tsx:209
#: src/containers/DeviceList/columns/mobile.tsx:358
#: src/containers/DeviceList/columns/desktop.tsx:206
msgid "Расход"
msgstr "Konsumpcja"

#. placeholder {0}: convertTimestampToLocalDateString( data.period.fromTs )
#. placeholder {1}: convertTimestampToLocalDateString( data.period.toTs )
#: src/containers/OraclePage/ComputeTab/utils.ts:228
msgid "Расходы для терминала были посчитаны за период с {0} по {1} (когда были продажи)."
msgstr "Wydatki dla terminala zostały obliczone za okres od {0} do {1} (kiedy były sprzedaże)."

#: src/containers/Dashboard/Geography/Geography.tsx:30
msgid "Регионы: {regionCount}"
msgstr "Regiony: {regionCount}"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:158
msgid "Редактирование аппарата"
msgstr "Edycja urządzenia"

#: src/containers/Encash/EncashComment.tsx:49
msgid "Редактирование комментария"
msgstr "Edycja komentarza"

#: src/containers/Users/UserMenu.tsx:204
#: src/containers/Staff/StaffForm.tsx:84
msgid "Редактировать"
msgstr "Redagować"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:160
msgid "Режим “Промоакция”"
msgstr "Tryb “Promocja”"

#: src/components/CartridgeValue/EditValueModal.tsx:91
msgid "Ресурс фильтров успешно обновлен"
msgstr "Zasób filtrów został pomyślnie zaktualizowany"

#: src/locales/constants.ts:54
msgid "Роль"
msgstr "Rola"

#: src/containers/Dashboard/AllMoney/utils.ts:24
msgid "Ручная корректировка"
msgstr "Ręczna korekta"

#: src/containers/Dashboard/AllMoney/utils.ts:47
msgid "Ручные корректировки"
msgstr "Ręczne korekty"

#: src/containers/Migrations/Migrations.tsx:338
msgid "с"
msgstr "s"

#: src/features/serviceNotification/ServiceNotification.tsx:26
msgid "С 22:00 13 октября (МСК) по 01:00 14 октября (МСК), на коммуникационном оборудовании запланированы профилактические работы. В это время может наблюдаться недоступность системы GSM мониторинга и/или задержки в получении данных телеметрии от водоматов. Суммарное время перерыва составит не более 30 минут. Приносим извинения за доставленные неудобства."
msgstr "Od 22:00 13 października (MSK) do 01: 00 14 października (MSK) planowane są prace profilaktyczne na sprzęcie komunikacyjnym. W tym czasie może wystąpić niedostępność systemu monitorowania GSM i/lub opóźnienia w odbiorze danych telemetrycznych z wodomierzy. Całkowity czas przerwy wyniesie nie więcej niż 30 minut. Przepraszamy za niedogodności."

#: src/containers/Migrations/Migrations.tsx:2656
msgid "с аппаратами"
msgstr "z urządzeniami"

#: src/containers/Users/UserMenu.tsx:139
#: src/components/CartridgeValue/ResetButton.tsx:22
msgid "Сбросить"
msgstr "Resetuj"

#: src/containers/Users/UserMenu.tsx:208
msgid "Сбросить пароль"
msgstr "Zresetuj hasło"

#: src/containers/Users/UserMenu.tsx:138
msgid "Сбросить пароль пользователя?"
msgstr "Zresetować hasło użytkownika?"

#: src/containers/Migrations/Migrations.tsx:1169
msgid "Свободен"
msgstr "Wolny"

#: src/containers/Migrations/Migrations.tsx:2364
msgid "Сервис"
msgstr "Usługa"

#: src/containers/Migrations/Migrations.tsx:1092
msgid "Синхронизация счётчиков telemetry в Redis"
msgstr "Synchronizacja liczników telemetry w Redis"

#: src/containers/Migrations/Migrations.tsx:2876
msgid "Синхронизировать аппараты"
msgstr "Synchronizuj urządzenia"

#: src/containers/Migrations/Migrations.tsx:2754
msgid "Синхронизировать пользователей"
msgstr "Synchronizuj użytkowników"

#: src/containers/Profile/EditProfile.tsx:92
msgid "Смена пароля"
msgstr "Zmiana hasła"

#: src/containers/Migrations/Migrations.tsx:2890
msgid "Сменили владельца: {reassignedDeviceCount}"
msgstr "Urządzenia ze zmienionym właścicielem: {reassignedDeviceCount}"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:101
msgid "Событие"
msgstr "Wydarzenie"

#: src/containers/Migrations/Migrations.tsx:582
#: src/containers/Migrations/Migrations.tsx:831
#: src/containers/Migrations/Migrations.tsx:3073
msgid "События"
msgstr "Zdarzenia"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:171
msgid "Совпадение строк"
msgstr "Zgodność wierszy"

#: src/containers/DeviceList/AuditTab/AuditTab.tsx:210
msgid "Сортировать по дате"
msgstr "Sortuj według daty"

#: src/containers/Migrations/Migrations.tsx:3035
msgid "Состав переносимых данных"
msgstr "Struktura migrowanych danych"

#: src/containers/Terminals/Terminal/Device.tsx:94
msgid "Состояние"
msgstr "Stan"

#: src/containers/Terminals/Terminal/DeviceState/BotlerStatus.tsx:33
msgid "Состояние бутылочника"
msgstr "Konfiguracja rozlewni"

#: src/containers/Omnidesk/Omnidesk.tsx:36
msgid "Сотрудник"
msgstr "Pracownik"

#: src/config/menu.tsx:124
msgid "Сотрудники"
msgstr "Pracownik"

#: src/containers/Migrations/Migrations.tsx:1098
msgid "Сохранение резервной копии в MinIO"
msgstr "Zapisywanie kopii zapasowej w MinIO"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:109
#: src/components/DeviceRemain.tsx:48
#: src/components/LastServiceDate/LastServiceDate.tsx:170
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:77
msgid "Сохранить"
msgstr "Zachować"

#: src/features/deviceAlerts/i18n/translations.ts:16
msgid "Сработал датчик малого уровня воды в баке"
msgstr "Zadziałał czujnik niskiego poziomu wody w zbiorniku"

#: src/features/deviceAlerts/i18n/translations.ts:10
msgid "Сработал датчик низкого давления"
msgstr "Zadziałał czujnik niskiego ciśnienia"

#: src/features/deviceAlerts/i18n/translations.ts:11
msgid "Сработал датчик открытия двери"
msgstr "Zadziałał czujnik otwarcia drzwi"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:146
msgid "Сравнение состояний аппарата"
msgstr "Porównanie stanów urządzenia"

#: src/containers/Migrations/Migrations.tsx:968
msgid "Сравнить состояния аппарата"
msgstr "Porównaj stany urządzenia"

#: src/containers/Sales/DeviceIncome.tsx:30
msgid "Средства зачислены"
msgstr "Środki zostały zaksięgowane"

#: src/components/ConnectBot/ConnectMaxBot.tsx:95
#: src/components/ConnectBot/ConnectMaxBot.tsx:109
#: src/components/ConnectBot/ConnectBot.tsx:95
#: src/components/ConnectBot/ConnectBot.tsx:114
msgid "Ссылка скопирована в буфер обмена"
msgstr "Link skopiowany do schowka"

#: src/containers/UserInfo/UserInfo.tsx:91
#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:104
msgid "Статистика"
msgstr "Statystyki"

#: src/containers/Dashboard/Users/Users.tsx:62
msgid "Статистика по месяцам"
msgstr "Statystyki miesięczne"

#: src/locales/constants.ts:55
#: src/containers/Migrations/Migrations.tsx:2367
msgid "Статус"
msgstr "Status"

#: src/containers/Migrations/Migrations.tsx:566
#: src/containers/Migrations/Migrations.tsx:809
msgid "Статус миграции"
msgstr "Status migracji"

#: src/containers/Migrations/Migrations.tsx:2241
#: src/containers/Migrations/Migrations.tsx:2246
msgid "Статус миграции изменён: {updatedCount}"
msgstr "Zmieniono status migracji: {updatedCount}"

#: src/containers/Migrations/Migrations.tsx:561
#: src/containers/Migrations/Migrations.tsx:798
#: src/containers/Migrations/Migrations.tsx:2374
msgid "Статус оценки"
msgstr "Status szacowania"

#: src/features/uvLampStatus/components/UVLampStatusSwitch.tsx:7
msgid "Статус УФ лампы"
msgstr "Lampa UV status"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:42
msgid "Статус шторки"
msgstr "Status kurtyny"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:125
msgid "Статусы worker pod'ов"
msgstr "Statusy podów workerów"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:58
msgid "Стоимость литра"
msgstr "Koszt litra"

#: src/containers/UserGroups/useUserGroupColumns.tsx:35
msgid "Страна"
msgstr "Kraj"

#: src/containers/Dashboard/Geography/Geography.tsx:24
msgid "Страны"
msgstr "Kraje"

#: src/containers/DeviceList/columns/filtersColumns.tsx:23
msgid "Ступени очистки <0/>"
msgstr "Stopnie oczyszczania <0/>"

#: src/containers/Services/BalanceHistory.tsx:32
msgid "Сумма"
msgstr "Kwota"

#: src/containers/Services/Recharge.tsx:155
msgid "Сумма в рублях"
msgstr "Kwota w rublach"

#. placeholder {0}: formatMoney(data.income, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:244
msgid "Суммарная выручка = {0}"
msgstr "Łączny przychód = {0}"

#: src/features/salesDynamics/ui/SalesDynamicsTotal.tsx:40
msgid "Суммарная динамика продаж"
msgstr "Łączna dynamika sprzedaży"

#. placeholder {0}: formatMoney(data.profit, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:245
msgid "Суммарная прибыль = {0}"
msgstr "Łączny zysk = {0}"

#. placeholder {0}: formatMoney(data.expenses, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:242
msgid "Суммарные операционные расходы = {0}"
msgstr "Łączne koszty operacyjne = {0}"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:20
msgid "Счетчик ХВС"
msgstr "Licznik wody wejściowej"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:19
msgid "Счетчик Электроэнергии"
msgstr "Licznik energii elektrycznej"

#: src/containers/Migrations/Migrations.tsx:2444
msgid "Текущее потребление DynamoDB"
msgstr "Bieżące zużycie DynamoDB"

#: src/containers/Migrations/Migrations.tsx:2515
msgid "Текущий лимит"
msgstr "Bieżący limit"

#: src/newComponents/Faq/Faq.tsx:55
msgid "Телеграмм чат технической поддержки <0>@alivewaternewbot</0>"
msgstr "Telegram czat pomocy technicznej <0>@alivewaternewbot</0>"

#: src/containers/Migrations/Migrations.tsx:3074
msgid "Телеметрия"
msgstr "Telemetria"

#: src/containers/Migrations/Migrations.tsx:3068
msgid "Телеметрия ÷ 10"
msgstr "Telemetria ÷ 10"

#: src/containers/Migrations/Migrations.tsx:3067
msgid "Телеметрия ÷ 5"
msgstr "Telemetria ÷ 5"

#: src/locales/constants.ts:53
msgid "Телефон"
msgstr "Telefon"

#: src/locales/constants.ts:18
msgid "Телефон поддержки"
msgstr "Numer telefonu pomocy technicznej"

#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:21
#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:33
msgid "Температура включения больше или равна температуре выключения"
msgstr "Temperatura włączenia jest większa lub równa temperaturze wyłączenia"

#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:27
#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:39
msgid "Температура выключения меньше или равна температуре включения"
msgstr "Temperatura wyłączenia jest mniejsza lub równa temperaturze włączenia"

#. placeholder {0}: data.address
#: src/containers/OraclePage/ComputeTab/utils.ts:212
msgid "Терминал по адресу {0}"
msgstr "Terminal pod adresem {0}"

#: src/containers/Main/Main.tsx:79
msgid "Техническая поддержка<0/>с 07: 00 до 21: 00 МСК"
msgstr "Help desk <0/> Not awailable"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:98
#: src/config/menu.tsx:130
msgid "Технические работы"
msgstr "Prace techniczne"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:106
msgid "Технические работы (aka \"шторка\")"
msgstr "Prace techniczne (aka \"kurtyna\")"

#: src/components/Stats/constants.ts:19
msgid "Тип воды"
msgstr "Rodzaj wody"

#: src/locales/constants.ts:6
msgid "Точный адрес установки аппарата"
msgstr "Dokładny adres instalacji urządzenia"

#: src/components/Stats/TrendsLegend.tsx:22
msgid "Тренд"
msgstr "Trend"

#: src/features/serviceNotification/ServiceNotification.tsx:21
msgid "Уведомление о проведении сервисных работ"
msgstr "Zawiadomienie o przeprowadzeniu prac serwisowych"

#: src/containers/Migrations/Migrations.tsx:1102
msgid "Удаление временных файлов"
msgstr "Usuwanie plików tymczasowych"

#: src/containers/Migrations/Migrations.tsx:2891
msgid "Удалено аппаратов: {removedDeviceCount}"
msgstr "Usunięto urządzenia: {removedDeviceCount}"

#: src/containers/Users/UserMenu.tsx:115
#: src/containers/Terminals/Terminal/TerminalTitle.tsx:88
#: src/containers/Staff/StaffForm.tsx:87
msgid "Удалить"
msgstr "Usunąć"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:87
msgid "Удалить аппарат?"
msgstr "Usunąć urządzenie?"

#: src/containers/Users/UserMenu.tsx:218
msgid "Удалить пользователя"
msgstr "Usuń użytkownika"

#: src/containers/Users/UserMenu.tsx:114
msgid "Удалить пользователя?"
msgstr "Usunąć użytkownika?"

#: src/containers/Migrations/Migrations.tsx:2817
msgid "Удобный формат времени"
msgstr "Wygodny format czasu"

#: src/containers/Migrations/Migrations.tsx:1924
msgid "Уже выполняется миграция другого пользователя"
msgstr "Migracja innego użytkownika jest już uruchomiona"

#: src/containers/Migrations/Migrations.tsx:1846
msgid "Уже выполняется оценка другого пользователя. Дождитесь её завершения."
msgstr "Trwa już szacowanie dla innego użytkownika. Poczekaj na jego zakończenie."

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:117
msgid "УЗ датчик"
msgstr "Czujnik ultradźwiękowy"

#. placeholder {0}: formatMoney(price * MAX_INCOME_LIMIT, currency)
#: src/containers/Sales/DeviceIncome.tsx:96
msgid "Укажите сумму для пополнения баланса на выбранном аппарате для покупки воды. Максимальная сумма пополнения - {0}"
msgstr "Podaj kwotę do doładowania salda na wybranym urządzeniu do zakupu wody. Maksymalna kwota doładowania - {0}"

#: src/containers/Migrations/Migrations.tsx:2563
msgid "Управление процессами"
msgstr "Zarządzanie procesami"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:101
msgid "Уровень сигнала"
msgstr "Siła sygnału"

#: src/containers/Dashboard/BillingStats/columns.tsx:38
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:15
msgid "Услуга"
msgstr "Service"

#: src/config/menu.tsx:72
msgid "Услуги"
msgstr "Usługi"

#: src/containers/Dashboard/BillingStats/columns.tsx:63
msgid "Успешно обработано"
msgstr "Processed success"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:53
msgid "Устройство включено"
msgstr "Urządzenie włączone"

#: src/containers/Terminals/Terminal/Device.tsx:84
msgid "Устройство заблокировано из-за не хватки средств"
msgstr "Urządzenie zablokowane z powodu braku środków"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:57
#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:65
msgid "Устройство обновлено"
msgstr "Urządzenie zostało zaktualizowane"

#: src/containers/Migrations/Migrations.tsx:2414
msgid "Утилизация CPU pod"
msgstr "Wykorzystanie CPU poda"

#: src/containers/DeviceList/columns/desktop.tsx:102
msgid "УФ лампа"
msgstr "Lampa UV"

#: src/locales/constants.ts:47
msgid "Фамилия"
msgstr "Nazwisko"

#: src/containers/DeviceList/constants.ts:24
msgid "Фильтры"
msgstr "Filtry"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:54
msgid "Финансы"
msgstr "Finanse"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:104
msgid "Финансы - поступления"
msgstr "Finanse - wpływy"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:112
msgid "Финансы - списания"
msgstr "Finanse - odpisy"

#: src/containers/Terminals/Terminal/Device.tsx:117
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:25
msgid "Фискализация"
msgstr "Fiskalizacja"

#: src/containers/Migrations/Migrations.tsx:2449
msgid "Целевая нагрузка DynamoDB"
msgstr "Docelowe obciążenie DynamoDB"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:79
msgid "Цена 1 литра по банковской карте"
msgstr "Cena 1 litra na karcie bankowej"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:16
msgid "Цена бутылки, {currencySign}"
msgstr "Cena butelki, {currencySign}"

#: src/locales/constants.ts:8
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:67
msgid "Цена за литр"
msgstr "Cena za litr"

#: src/locales/constants.ts:10
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:86
msgid "Цена за литр минеральной воды"
msgstr "Cena za litr wody mineralnej"

#: src/locales/constants.ts:9
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:72
msgid "Цена за литр по IC карте"
msgstr "Cena za litr na kartę IC"

#: src/locales/constants.ts:27
#: src/containers/Migrations/Migrations.tsx:326
msgid "ч"
msgstr "g"

#: src/components/Stats/constants.ts:10
msgid "Час"
msgstr "Godzina"

#: src/locales/constants.ts:13
msgid "Часовой пояс"
msgstr "Strefa czasowa"

#: src/containers/Omnidesk/OmniChat.tsx:44
msgid "Чат"
msgstr "Chat"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:102
msgid "четырехстрочный"
msgstr "czterolinijkowy"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:106
msgid "четырехстрочный с десятыми долями баланса"
msgstr "czterolinijkowy z dziesiętnymi częściami salda"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:70
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:60
#: src/components/ConnectBot/ConnectMaxBot.tsx:163
#: src/components/ConnectBot/ConnectBot.tsx:171
#: src/components/CartridgeValue/EditValueModal.tsx:96
msgid "Что-то пошло не так"
msgstr "Coś poszło nie tak"

#: src/locales/constants.ts:21
msgid "Широта"
msgstr "Szerokość geograficzna"

#: src/config/menu.tsx:93
#: src/config/menu.tsx:99
msgid "Школа вендора"
msgstr "Szkoła sprzedawcy"

#: src/components/LastServiceDate/LastServiceDate.tsx:149
msgid "Это действие изменит дату обслуживания для ВСХ аппаратов в вашем личном кабинете! Вы уверены?"
msgstr "Ta akcja zmieni datę serwisową dla wszystkich urządzeń na twoim koncie osobistym! Na pewno?"

#: src/components/CartridgeValue/EditValueModal.tsx:154
msgid "Я поменял счётчик ХВС"
msgstr "Wymieniłem licznik zimnej wody"
